<template>
  <div class="layout-box">
    <LayoutHeader headtitle="新智造"></LayoutHeader>
    <div class="secondary-content">
      <GoBack></GoBack>
      <div class="experts-title">
        <div class="bread-crumb-nav">当前位置：首页 > <a @click="$router.back()">新智造</a> > 应用详情</div>
      </div>
      <div class="experts-detail">
        <div class="character-profile clear">
          <img :src="smartdata.logos" v-if="smartdata.logos"/>
          <div class="character-profile-div">
            <h3>{{ smartdata.name }}</h3>
            <p class="research">{{smartdata.describe}}</p>
            <div class="pingjia">
              <p>综合评分：<i class="iconfont icon-shoucang"></i><i class="iconfont icon-shoucang"></i><i class="iconfont icon-shoucang"></i><i class="iconfont icon-shoucang"></i><i class="iconfont icon-shoucang"></i></p>
              <p>支付方式：在线支付</p>
            </div>
          </div>
          <div class="purchase-intention"><a class="btn-sy" v-if="smartdata.issy!=''">在线试用</a><a class="btn-xq" @click="gotourl(smartdata.url)" target="_blank">立即使用</a></div>
        </div>
        <div>&nbsp;</div>
        <div class="main-works">
          <h3>应用介绍:</h3>
        </div>
        <div class="details-introduction" id="new_smart">
          <p v-html="smartdata.introduce"></p>
          <img :src="smartdata.img" v-if="smartdata.img">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LayoutHeader from '../layout/layout-header2';
import GoBack from '../layout/layout-goback';
import myStorage from "../../bll/utils";

export default {
  name: 'NewSmartD',
  components:{
    LayoutHeader,
    GoBack
  },
  data () {
    return {
      smartdata:[],
      data_cont:[
      {id:1,name:'供应链经营',typeimg:require('../../assets/img/xzz-gyljy.jpg'),
        datas:[
          {ids:1,name:'生产计划管理APP',comp:'',logos:require('../../assets/img/yingyong/1-1.jpg'),img:require('../../assets/img/yingyong/1.jpg'),issy:'',isxq:true,describe:'计划管理APP通过supOS工业操作系统，与全厂信息系统互联互通，实现生产计划管理和计划优化等业务。根据工艺流程特点和业务需求，为企业年度、季度和月度生产计划的制定提供支撑，以实现企业效益最大化。根据市场需求和装置结构，装置加工方案和产品结构，降低生产成本，增加企业生产经营效益',introduce:'计划管理APP通过supOS工业操作系统，与全厂信息系统互联互通，实现生产计划管理和计划优化等业务。<br>\n' +
              '根据工艺流程特点和业务需求，建立生产计划管理APP，为企业年度、季度和月度生产计划的制定提供支撑，以实现企业效益最大化。根据市场需求和装置结构，装置加工方案和产品结构，降低生产成本，增加企业生产经营的效益。<br>\n' +
              '具体业务功能包括以下几项：<br>\n' +
              'a、计划编制——生产计划的编制是建立在需求计划的基础上，结合工厂产能计划、生产方式，形成供应计划；根据月度情况进行生产计划、能源消耗计划、原料进厂计划、产品出厂计划的编制工作。<br>\n' +
              'b、计划审核发布——在计划编制完成之后，需经过审核审批等流程环节，最终确定。平台支持工作流功能，在工作流程发生变化时，可以进行组态，不需要开发即可适应。与供应链运营进行集成，计划审核通过之后，在领导驾驶舱、个人工作台等进行信息发布，供销售、生产、财务等相关人员查询。<br>\n' +
              'c、计划跟踪分析——将实际生产数据与计划数据、上月数据、去年同期数据进行对比，生成当前生产计划完成率、环比数据、同比数据，并根据设定条件进行进度超限报警。<br>\n' +
              'd、计划优化分析——支持计划优化、需求预测，根据销售历史数据、季节变化情况等因素，通过建立需求预测模型，再结合人工经验，辅助计划人员形成需求计划，优化生产计划和提高需求预测准确性。<br>\n' +
              'e、盈利性分析——针对编制的生产计划，结合营销价格预测数据、财务生产成本数据，进行盈利能力分析，协助计划人员选择盈利能力最大的计划方案。<br>\n'},
          {ids:48,name:'KSP供应链管理平台',comp:'',logos:require('../../assets/img/yingyong/48-1.jpg'),issy:'',isxq:true,describe:'荆艺供应链管理平台，从原材料的采购销售开始，到最终成品送至目标客户手中，贯穿整个供应链所有环节的全程管理，为供应链企业提供物流、资金流、信息流的协调统一，实现了集团业务财务一体化',introduce: '<div class="content">\n' +
              '       \t\t\t\t\t\t<div class="detail-description-mod-content" style="color:#6F7479;font-family:-apple-system, &quot;font-size:14px;background-color:#FFFFFF;">\n' +
              '\t<div class="content-title" id="brightSpotTitle" style="font-size:16px;color:#252B3A;">\n' +
              '\t\t商品亮点\n' +
              '\t</div>\n' +
              '\t<ul class="brightSpot por-list por-list-circle" style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t<li id="brightSpot0" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t1、通过统一的订单中心、财务中心、决策中心，实现供应链业务的事前计划、事中控制等的完整管理体系\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot1" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t2、作业执行层面的操作分离、操作界面可配置，最大限度地减少系统变更对业务操作的影响\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot2" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t3、操作的个性化、管理的集中、技术平台的可配置，解决供应链业务灵活多变的问题\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot3" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t4、底层基础平台、顶层的数据交换平台，确保系统所有数据能够与内部、外部交换，实现供应链全程可视的保障\n' +
              '\t\t</li>\n' +
              '\t</ul>\n' +
              '</div>\n' +
              '<div class="detail-description-mod-content" style="color:#6F7479;font-family:-apple-system, &quot;font-size:14px;background-color:#FFFFFF;">\n' +
              '\t<div id="detail-description-desc-title" class="content-title" style="font-size:16px;color:#252B3A;">\n' +
              '\t\t商品说明\n' +
              '\t</div>\n' +
              '\t<table class="versionTable" style="margin:12px 0px 17px;/* width:1216px; */">\n' +
              '\t\t<tbody>\n' +
              '\t\t\t<tr>\n' +
              '\t\t\t\t<td id="product-description-0">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">版本:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">V6.0</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t\t<td id="product-description-1">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">交付方式:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">License</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t</tr>\n' +
              '\t\t\t<tr>\n' +
              '\t\t\t\t<td id="product-description-2">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">适用于:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">Windows/Linux</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t\t<td id="product-description-3">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">上架日期:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">2020-11-17</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t</tr>\n' +
              '\t\t\t<tr>\n' +
              '\t\t\t\t<td id="product-description-4">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">交付SLA:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">60 自然日</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t\t<td id="product-description-5">\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t</tr>\n' +
              '\t\t</tbody>\n' +
              '\t</table>\n' +
              '\t<div id="detail-description-desc" class="detail-description-desc" style="color:#666A75;">\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\tKinnSoft供应链管理平台（简称KSP），是荆艺软件十多年物流、贸易行业信息化经验的结晶，提炼并吸收上千家物流、贸易相关行业企业的管理经验，结合供应链先进管理理念及发展方向，为综合型物流集团企业精心打造的、专业的、灵活且高效的供应链管理整体解决方案。供应链管理平台包含订单中心、客户关系管理（CRM）、海运货代管理、船代管理、船东管理、空运货代管理、报关管理、保税管理、仓储管理、配送管理、运输管理（公路运输、铁路运输、拖车管理、车辆管理等）、堆场管理、贸易管理、销售分销管理、消息平台、单据管理、结算中心、财务管理、资金管理、决策支持中心等系统模块，贯穿供应链各个环节，将企业运作中的信息资源整合在一起，降低交流成本，提高运作效率和准确性，加强企业内部的管理与监控，为综合物流企业提供业务财务一体化的服务平台。 KSP分三大部分：物流作业平台、企业内部运作（物流执行支持系列、财务管理支持系列）、客户服务中心。 1、物流作业平台 作为整个供应链平台的基础，管理所有的基础代码设置、用户档案、组织及权限体系、客户关系相关信息，实现了所有基础资料完全集中统一管理的目的。 2、企业内部运作 包含物流执行支持系列和财务管理支持系列，面向供应链的不同作业环节管理，支撑综合物流集团企业内部管理运作，记录业务及财务流程上每个操作细节，融合了各种自定义审批流程，各个操作和审批环节在系统内部进行信息传递，实现了无纸化办公，并且可通过订单中心对每个订单执行过程进行全程管理与监控。物流执行支持系列与财务管理支持系列通过完美的结算体系紧密结合，实现了业务财务一体化。 3、客户服务中心 协同作业系列，企业与外部商务伙伴建立密切协作的工具，面向外部商务伙伴（客户和供应商）的信息交互平台，加强企业与客户或供应商之间的实时信息交流。通过Internet，企业外部用户可以在自助作业平台直接网上录入或采用商务数据连接件传递EDI数据的方式给企业下达订单，并且可通过APP查询自身相关业务的操作情况，反馈各方面意见等。订单中心接收客户订单之后，进行任务分配，各个业务部门接到操作指令后进行相应的业务操作，实现在一个订单页面下达各种类别操作指令的功能。\n' +
              '\t\t</p>\n' +
              '\t</div>\n' +
              '</div>       \t\t\t\t\t\t</div>'},
          {ids:49,name:'甄云甄采云SRM解决方案',comp:'',logos:require('../../assets/img/yingyong/49-1.jpg'),issy:'',isxq:true,describe:'甄云-甄采云数字采购云平台 通过供应商管理、战略寻源、供应链敏捷协同、企业采购商城、云应用商城、智能分析等6大套件助力企业快速完成采购数字化转型。',introduce: '<div class="content">\n' +
              '       \t\t\t\t\t\t<div class="detail-description-mod-content" style="color:#6F7479;font-family:-apple-system, &quot;font-size:14px;background-color:#FFFFFF;">\n' +
              '\t<div class="content-title" id="brightSpotTitle" style="font-size:16px;color:#252B3A;">\n' +
              '\t\t商品亮点\n' +
              '\t</div>\n' +
              '\t<ul class="brightSpot por-list por-list-circle" style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t<li id="brightSpot0" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t快速迭代实施\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot1" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t基于公有云的灵活配置\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot2" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t超过600家大型客户30个行业成功实施\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot3" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t云部署自迭代\n' +
              '\t\t</li>\n' +
              '\t</ul>\n' +
              '</div>\n' +
              '<div class="detail-description-mod-content" style="color:#6F7479;font-family:-apple-system, &quot;font-size:14px;background-color:#FFFFFF;">\n' +
              '\t<div id="detail-description-desc-title" class="content-title" style="font-size:16px;color:#252B3A;">\n' +
              '\t\t商品说明\n' +
              '\t</div>\n' +
              '\t<table class="versionTable" style="margin:12px 0px 17px;">\n' +
              '\t\t<tbody>\n' +
              '\t\t\t<tr>\n' +
              '\t\t\t\t<td id="product-description-0">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">版本:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">V1.0</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t\t<td id="product-description-1">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">交付方式:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">SaaS</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t</tr>\n' +
              '\t\t\t<tr>\n' +
              '\t\t\t\t<td id="product-description-2">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">适用于:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">Windows</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t\t<td id="product-description-3">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">上架日期:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">2021-03-16</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t</tr>\n' +
              '\t\t</tbody>\n' +
              '\t</table>\n' +
              '\t<div id="detail-description-desc" class="detail-description-desc" style="color:#666A75;">\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t甄采云，通过采购数字化平台为企业提供战略寻源套件、供应链敏捷协同套件、采购商城套件，企业应用商城四大套件，为企业采购内外部协作和交易提供一体化SaaS平台。平台可与企业内部ERP、OA、HR等系统无缝集成。<img alt="介绍5.jpg" class="mce_image " id="image_images_mce_9" src="https://portal-data-cn.obs.cn-north-4.myhuaweicloud.com/marketplace/public/app/picture/image/20210315/4a5e24c0-b577-4d8c-b24d-069024eec23f/2103151444453440.jpeg" style="">\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t供应商生命周期管理，覆盖供应商准入过程、分类、风险管理、自动化绩效等模块完善企业供应商管理体系。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t<img alt="1001.jpg" class="mce_image " id="image_images_mce_10" src="https://portal-data-cn.obs.cn-north-4.myhuaweicloud.com/marketplace/public/app/picture/image/20210315/5b06f082-96d6-4522-aff8-64a2fb8db389/2103151454151244.jpeg" style="width:1216px;">\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t战略寻源套件涵盖企业同采购申请到合同过程，为企业解决采购需求到定商定价的全过程数字化管理，让采购过程更加高效阳光。未来战略寻源套件将开放撮合交易服务，为云平台的所有用户提供优质的寻源/拓客服务，搭建新型的B2B平台。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t<img alt="1002.png" class="mce_image " id="image_images_mce_11" src="https://portal-data-cn.obs.cn-north-4.myhuaweicloud.com/marketplace/public/app/picture/image/20210315/94a2daa2-38a0-4a36-b7d8-4b7dbb2a85bd/2103151455029219.png" style="width:1216px;">\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t供应链敏捷协同套件，主要服务于生产制造型企业，是智能制造、工业互联网平台重要的组成套件。该套件为企业提供链接上游供应链的协作平台，让生产计划、采购计划、订单、送货物流、对账付款全程数字化可视化，响应国家供应链创新应用的协作平台。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t<img alt="1003.jpg" class="mce_image " id="image_images_mce_12" src="https://portal-data-cn.obs.cn-north-4.myhuaweicloud.com/marketplace/public/app/picture/image/20210315/497a9efa-d866-4d88-89be-6434ed231c9d/2103151455112565.jpeg" style="width:1216px;">\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t采购商城套件融入众多电商平台采购商品，直接打通企业与电商平台的交易环节。针对企业采购通用物资、MRO物资等可通过商城套件快捷阳光采购。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t<img alt="1005.jpg" class="mce_image " id="image_images_mce_13" src="https://portal-data-cn.obs.cn-north-4.myhuaweicloud.com/marketplace/public/app/picture/image/20210315/bf035eb3-a176-499b-9221-94da3ad205ee/2103151455273020.jpeg" style="width:1216px;">\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t企业应用商城是甄云的开放生态平台，该平台融合甄云与合作伙伴的联合数字化解决方案，目前已引入征信平台、企业风控平台、电子签章、电子发票、大数据分析等应用，开通服务后即可在甄云的一体化平台中使用，未来将继续融入更多合作伙伴，共同为企业采购提供价值。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t商品各规则组合服务：\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t供应商生命周期：提供供应商管理套件，覆盖从供应商注册到准入、合作到淘汰过程管理。<br>\n' +
              '采购协同：提供协同套件，覆盖预测、订单、送货、财务等业务业务流程协同。<br>\n' +
              '战略寻源套件：提供寻源套件，覆盖从需求提出，到寻源定价，合同签订过程的管理。<br>\n' +
              '商城管理：一站式非生采购商城，可对多个电商平台商品进行合并展示，直接进行多电商平台采购。\n' +
              '\t\t</p>\n' +
              '\t</div>\n' +
              '</div>       \t\t\t\t\t\t</div>'},
          {ids:2,name:'供应链服务平台',comp:'',logos:require('../../assets/img/yingyong/2-1.jpg'),issy:'',isxq:true,describe:'供应链平台是服务于物流供应链各企业的信息化平台，为上游企业提供供应链信息化服务，物流企业提供运输管理、仓储管理、同城配送等企业级应用，同时为物流园区提供智慧园区相关信息系统建设。',introduce: '<div class="content">\n' +
              '       \t\t\t\t\t\t<div class="detail-description-mod-content" style="color:#6F7479;font-family:-apple-system, &quot;font-size:14px;background-color:#FFFFFF;">\n' +
              '\t<div class="content-title" id="brightSpotTitle" style="font-size:16px;color:#252B3A;">\n' +
              '\t\t商品亮点\n' +
              '\t</div>\n' +
              '\t<ul class="brightSpot por-list por-list-circle" style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t<li id="brightSpot0" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t智慧物流\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot1" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t供应链金融\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot2" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t人工智能\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot3" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t大数据\n' +
              '\t\t</li>\n' +
              '\t</ul>\n' +
              '</div>\n' +
              '<div class="detail-description-mod-content" style="color:#6F7479;font-family:-apple-system, &quot;font-size:14px;background-color:#FFFFFF;">\n' +
              '\t<div id="detail-description-desc-title" class="content-title" style="font-size:16px;color:#252B3A;">\n' +
              '\t\t商品说明\n' +
              '\t</div>\n' +
              '\t<table class="versionTable" style="margin:12px 0px 17px;">\n' +
              '\t\t<tbody>\n' +
              '\t\t\t<tr>\n' +
              '\t\t\t\t<td id="product-description-0">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">版本:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">V1.0</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t\t<td id="product-description-1">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">交付方式:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">License</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t</tr>\n' +
              '\t\t\t<tr>\n' +
              '\t\t\t\t<td id="product-description-2">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">适用于:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">Windows/Android/iOS</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t\t<td id="product-description-3">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">上架日期:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">2019-09-19</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t</tr>\n' +
              '\t\t</tbody>\n' +
              '\t</table>\n' +
              '\t<div id="detail-description-desc" class="detail-description-desc" style="color:#666A75;">\n' +
              '\t\t平台包括子系统：运输管理（TMS）系统、仓储管理（TMS）系统、同城配送系统、物流信息管理系统、车队管理系统、货代管理系统、办公信息系统、供应链管理系统、供应链金融服务系统、供应链大数据分析系统以及智慧园区相关系统。<br>\n' +
              '运输管理系统<br>\n' +
              '由于传统物流行业操作过程复杂，手续繁多，业务信息多，围绕这些信息处理也很纷杂。而且，物流行业竞争激烈，这种竞争，一方面表现再发展在客户市场开拓上，另一方面也存在于收集信息处理的速度、广度和深度，以及在业务操作中对业务数据处理的准确性和严密性，更高层次上，还牵涉到公司决策对整体业务的控制和协调。<br>\n' +
              '物流SAAS管理系统从物流行业的实际需求出发，系统从完善基础信息设置到货物的运输管理、订单管理到数据分析、结算管理以及SAAS用户、系统用户的管理，到最后各种报表生成，清晰的业务流程，使操作人员能够按照流程清晰的进行实际的操作，保证物流运作有序而高效的进行。<br>\n' +
              '仓储管理系统<br>\n' +
              '主要实现货物入库、库存和出库的管理过程。系统需要从完善基础信息设置到出库入库管理、盘库报损溢等库内作业管理、库存预警、租赁管理以及SAAS用户、系统用户的管理，到最后各种报表生成，将仓储业务的流程更加清晰的表现，使仓储业务各环节更加透明化，提升仓储管理员的工作效率。提高仓库存储效率，降低仓库空位率，保障仓库利用最大化。<br>\n' +
              '同城配送SAAS平台<br>\n' +
              '同城配送目的是为了服务于运输管理、仓储管理、供应链管理得订单。更好维系客户黏度，提升客户满意度。<br>\n' +
              '大数据分析平台<br>\n' +
              '目前企业各机构积累了大量的业务数据，数据分散在不同的excel中，每级用户需要手工维护excel的版本，并通过邮件进行报送，数据利用程度有限。监管部门如何有效的管理这些数据，如何充分挖掘业务数据的价值，是监管部门的迫切需求。核心为供应链大数据分析和物流大数据分析。并通过算法模型提炼出更为有效的分析数据。<br>\n' +
              '供应链大数据分析主要着重为市场资源分析与库存预警分析，也应衍生出供应链计划分析、协同效率分析来充实整个供应链大数据池。<br>\n' +
              '物流管理信息系统<br>\n' +
              '物流管理信息系统，打通物流供应链，公路，铁路联运管理平台，为客户降低了物流成本，提高了运输效率，推进多试联运，促进节能减排，实现信息联通，提高了物流服务水平。<br>\n' +
              '办公信息系统<br>\n' +
              '办公信息系统目的为办公人员提供信息服务，以提高办公效率和办公质量，从而获得经济效益和社会效益。其主要从内勤管理、人事管理、财务管理、客户管理、权限管理五个方面来去管理。<br>\n' +
              '从初始化用户角色、组织机构、分配权限、设定审批流。再到人员的请假、出差、加班、工作汇报管理办法。<br>\n' +
              '车队管理系统<br>\n' +
              '运输公司无论规模如何，车队管理都可能是一项繁琐，昂贵且耗时的活动。鉴于目前这种情况，运输公司需要对车队管理有一个高效稳定解决方案。并可以通过PC和移动端相结合提升交互体验。<br>\n' +
              '货代管理系统<br>\n' +
              '货代管理系统，是针对货代行业所特有的业务规范和管理流程，利用现代信息技术以及信息化的理论和方法，开发出的能够对货代企业的操作层、管理层和战略决策层提供有效支持与帮助的管理系统。<br>\n' +
              '货代管理系统应具备一个功能完整，集操作、管理、服务为一体的解决方案，功能覆盖货代公司运营的各个方面，有效支持市场部门、业务运作部门、财务部门的业务操作和管理，形成统一的企业应用平台<br>\n' +
              '具体需要包括：订单管理、操作管理、结算管理、数据分析、系统管理。其中订单管理需要根据进口、出口、内贸业务特性制定符合业务规范的流程管理。操作管理中主要以订单的处理办法为主，退单、分单和提单等。结算管理中主要为支持财务部门业务操作，其中包括费用管理、应收账单管理、应收发票管理、应付请款单管理、对账核销。<br>\n' +
              '还需对整个货代流转进行数据分析，业务统计分析、开票统计分析、毛利分析。<br>\n' +
              '供应链金融服务系统<br>\n' +
              '供应链金融可以解决中小企业供应链中资金分配的不平衡问题，打通上下游物流链、资金链、商流、信息流，提升整个供应链的群体竞争力。应链金融的实质是帮助企业盘活流动资产。<br>\n' +
              '从企业的档案基础信息完善，到需要提供应收帐款融资、预付款融资、库存融资、票据融资、运单融资、授信融资等融资服务，并且还需有一套完善的信用与风险管控体系，其中包括信用特权审批、预警管理、信用查询、风险监控、信用报告评估、风险评估等。<br>\n' +
              '物流供应链服务平台<br>\n' +
              '物流供应链系统需针物流行业特色来进行制定，其中需要有供应商管理、订单管理、采购管理、销售管理、库存管理、档案管理、数据分析来支撑整个供应链的运转，结合行业特殊企业管理办法去完善商品、供应商、采购销售再到出入库的整个流程。因供应链系统涉及到的部门繁杂，对系统部门组织需要规划进行设置，保证各部门人员能流畅操作或提交审批工作。\n' +
              '\t</div>\n' +
              '</div>       \t\t\t\t\t\t</div>'},
          {ids:3,name:'采购管理APP',comp:'',logos:require('../../assets/img/yingyong/3-1.jpg'),img:require('../../assets/img/yingyong/3.jpg'),issy:'',isxq:true,describe:'采购管理主要是对采购计划、采购订单和采购过程进行管理，包括采购计划的维护与审批、采购订单的维护与审批、询比价采购管理、招投标采购管理、框架协议采购管理、寄售业务采购管理、委外加工采购管理等。',introduce:'采购管理主要是对采购计划、采购订单和采购过程进行管理，包括采购计划的维护与审批、采购订单的维护与审批、询比价采购管理、招投标采购管理、框架协议采购管理、寄售业务采购管理、委外加工采购管理等。采购管理要与供应商管理交易系统在采购业务上有效兼顾，相辅相成。<br>\n' +
              '具体业务功能包括以下几项：<br>\n' +
              'a、采购计划——采购部门执行采购的主要依据是采购计划，按照需求管理，平衡库存，计划管理这三方面进行综合考虑并编制。采购需求多数情况下是分散产生的，平衡库存和计划管理则可以分散进行也可以集中进行。需求数量被作为计划独立需求，客户需求，相关需求，物料预留以及预测需求被维护。<br>\n' +
              'b、采购申请——采购申请是采购计划的结果，同时又是采购订单执行的开始，采购申请可以由采购计划运行生成，也可以由业务人员手工输入。<br>\n' +
              'c、货源确定/框架协议——针对采购需求和采购计划，采购部门需要采用购买、委托和租赁等方式确认供应源，可以提供多种确定采购计划供应商的业务流程，主要有：招投标采购、一次性采购、专一来源采购、多货源/商务谈判、长期协议采购。<br>\n' +
              'd、合同审批——根据京博石化的具体工作流程，在平台上设定审批流程，包括如下内容：批准条件、批准策略、批准标示，并关联采购申请、合同和采购订单等信息。<br>\n'},
          {ids:4,name:'财商管理APP',comp:'',issy:'',isxq:'',describe:'集中集成运营、销售、市场、物流、服务管理、金融等全流程的财务和商务数据信息，实现有效的数据统计、状态监控和挖掘分析，并通过直观、可视化的方式进行展现，为领导层的综合信息查询提供有效手段，为决策分析提供及时的数据支持。'},
          {ids:5,name:'销售管理APP',comp:'',issy:'',isxq:'',describe:'从目标管理、销售概况、销量分析、客户流失预警、价格管理、计划管理、运输费用、库存管理等8个方面进行营销过程管理。'},
          {ids:6,name:'仓储物流管理APP',comp:'',issy:'',isxq:'',describe:'通过supOS工业操作系统，实现智能立体仓库系统、物料管理(平衡优化)系统、进厂物料自动化取样系统、罐区储运管理、智能化装卸车系统、车辆移动跟踪系统（含定位）、进厂跟踪、排队叫号系统、无人地磅+车牌识别系统、装卸区导航大屏等系统功能及物流数据集成应用。'},
          {ids:7,name:'经营管理APP',comp:'',issy:'',isxq:'',describe:'根据公司、分厂、班组逐级钻取分析生产绩效指标(产能和设备台产)、能耗绩效指标(煤耗和电耗)、质量绩效指标(产成品质量合格率的绩效指标)'}
        ]
      },
      {id:2,name:'生产管控',typeimg:require('../../assets/img/xzz-scgk.jpg'),
        datas:[
          {ids:61,name:'工业生产能效管控平台',comp:'',logos:require('../../assets/img/yingyong/61-1.jpg'),img:require('../../assets/img/yingyong/61.jpg'),issy:true,isxq:true,url:'https://test.renter.dartzon.com/cockpit/screen?id=1&mode=2',describe:'打破“能源双控”政策下企业用能困境，实现能效精准管控，帮助企业节能减排，降本增效，助力企业实现能源数字化、可视化管理、节能减排，降本增效、精准计量计费、智能运维',introduce: '<div class="content">\n' +
              '       \t\t\t\t\t\t<div class="detail-description-mod">\n' +
              '\t\n' +
              '\t<div class="detail-description-mod-body">\n' +
              '\t\t<div class="detail-description-mod-content">\n' +
              '\t\t\t<div class="content-title" id="brightSpotTitle">\n' +
              '\t\t\t\t商品亮点\n' +
              '\t\t\t</div>\n' +
              '\t\t\t<ul class="brightSpot por-list por-list-circle">\n' +
              '\t\t\t\t<li id="brightSpot0">精准计量计费</li>\n' +
              '\t\t\t\t<li id="brightSpot1">能源可视化</li>\n' +
              '\t\t\t\t<li id="brightSpot2">智能运维</li>\n' +
              '\t\t\t\t<li id="brightSpot3">节能减排</li>\n' +
              '\t\t\t\t\n' +
              '\t\t\t</ul>\n' +
              '\t\t</div>\n' +
              '\t\t<div class="detail-description-mod-content">\n' +
              '\t\t\t<div id="detail-description-desc-title" class="content-title">\n' +
              '\t\t\t\t商品说明\n' +
              '\t\t\t</div>\n' +
              '\t\t\t\n' +
              '\t\t\t<div id="detail-description-desc" class="detail-description-desc">\n' +
              '\t\t\t\t<p>依托云计算+物联网技术和对国家“碳达峰、碳中和”战略、能源消费革命、技术革命的深刻认知，为产业园区、工业生产企业、商业地产运营商等客户提供园区智慧能源管理、企业能效管理、园区计量计费运营、综合能源管理、碳资产运营等一站式解决方案，赋能企业实现能源数智化升级，引领产业高质量转型发展。</p>\n' +
              '\t\t\t\t\n' +
              '\t\t\t</div>\n' +
              '\t\t</div>\n' +
              '\t</div>\n' +
              '</div>       \t\t\t\t\t\t</div>'},
          {ids:18,name:'智能装卸车管理APP',comp:'',logos:require('../../assets/img/yingyong/18-1.jpg'),img:require('../../assets/img/yingyong/18.jpg'),issy:'',isxq:true,describe:'通过利用supOS的数据接入与整合能力，在原油与成品油的储运收发过程中，收发人员实时监控储罐装卸车的状态，实现储罐鹤位、储罐库存、收发油车辆等数据统一管理。',introduce:'在原油与成品油的储运收发过程中，收发人员需要实时监控储罐装卸车的状态，鹤位与产品、储罐的对应关系，及时发现问题并采取措施，保证原料、产品安全高效装车。但是整个业务过程涉及罐区系统、车辆调度系统、门岗系统、装卸车系统等，操作人员无法及时获得这些数据，工作效能极低。<br>\n' +
              '通过利用supOS的数据接入与整合能力，实现储罐鹤位、储罐库存、收发油车辆等数据统一管理。实时监控鹤位收发状态、储罐库存情况、装车状况等，车间操作人员能够实时把控鹤位、储罐、车辆、能耗、偏差、鹤位利用率和工作安排相关信息，装卸车状况可视化清晰展示在操作工面前，从而指导生产，提升装车工作效率。<br>\n' +
              '当前库存可装车数据统计与分析从原来的手工计算30分钟，降低到现在的5分钟以内，极大地提升了操作工的工作效率。<br>\n'},
          {ids:50,name:'新核云生产流程管理软件',comp:'',logos:require('../../assets/img/yingyong/50-1.jpg'),issy:'',isxq:true,describe:'新核云是面向离散制造企业的工厂数字化云ERP+MES。从生产流程管控切入车间管理，打通生产企业从订单，采购，生产管理，仓库等环节，帮助企业完成工厂数字化转型，进而落实柔性生产力的升',introduce: '<div class="content">\n' +
              '       \t\t\t\t\t\t<div class="detail-description-mod-content" style="color:#6F7479;font-family:-apple-system, &quot;font-size:14px;background-color:#FFFFFF;">\n' +
              '\t<div class="content-title" id="brightSpotTitle" style="font-size:16px;color:#252B3A;">\n' +
              '\t\t商品亮点\n' +
              '\t</div>\n' +
              '\t<ul class="brightSpot por-list por-list-circle" style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t<li id="brightSpot0" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t云端部署\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot1" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t软硬结合\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot2" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t行业深耕\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot3" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t超低门槛\n' +
              '\t\t</li>\n' +
              '\t</ul>\n' +
              '</div>\n' +
              '<div class="detail-description-mod-content" style="color:#6F7479;font-family:-apple-system, &quot;font-size:14px;background-color:#FFFFFF;">\n' +
              '\t<div id="detail-description-desc-title" class="content-title" style="font-size:16px;color:#252B3A;">\n' +
              '\t\t商品说明\n' +
              '\t</div>\n' +
              '\t<table class="versionTable" style="margin:12px 0px 17px;">\n' +
              '\t\t<tbody>\n' +
              '\t\t\t<tr>\n' +
              '\t\t\t\t<td id="product-description-0">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">版本:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">V1.0</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t\t<td id="product-description-1">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">交付方式:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">SaaS</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t</tr>\n' +
              '\t\t\t<tr>\n' +
              '\t\t\t\t<td id="product-description-2">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">适用于:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">Windows/Linux/Unix/Android/iOS/其他</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t\t<td id="product-description-3">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">上架日期:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">2020-09-28</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t</tr>\n' +
              '\t\t</tbody>\n' +
              '\t</table>\n' +
              '\t<div id="detail-description-desc" class="detail-description-desc" style="color:#666A75;">\n' +
              '\t\t在制品管理解决方案<br>\n' +
              '<br>\n' +
              '解决方案简述<br>\n' +
              '条码标签让每批在制品拥有自己的“ID”，看板检测每道工序的在制品堆积情况，扫码追溯他们的一切加工记录，促成优化排程和加工顺序，确保订单交期。<br>\n' +
              '解决方案详述<br>\n' +
              '· 批量。为车间现场每一批在制品指定唯一的条码标签用来追溯和流转，首道工序打印出条码并跟随物料流转，后道工序或检验人员通过手机APP扫码报工的加工时间，过程参数，检验数据都会记录在条码中，用于统计分析和追溯。<br>\n' +
              '· 看板。以工序汇总在制品情况，随着流转，数据会实时变化，能看到他们在每道工序中的堆积情况。<br>\n' +
              '· 追溯。通过扫码可查看对应批量的加工人、加工时间、加工设备、使用模具、加工参数、检验结果等记录。<br>\n' +
              '· 在制品优化（减少车间在制品）。通过生产提前期以及每道工序的加工时间，充分考虑订单、预测，不同产品的换型时间，优化排程和加工顺序，减少车间在制品，确保订单交期。<br>\n' +
              '解决方案应用<br>\n' +
              '客户介绍：<br>\n' +
              '某精密锻造有限公司创建于2004年5月，是由日本和中国合资的一家企业。从事工程机械零件、汽车、摩托车零配件的锻造件和机械加工件、模具的制造。创建以来先为日本AMC、力至优、久保田、山松森林、卡特比勒、美国汉森、苏州旭隆、宁波旭工、无锡旭英等多家企业配套生产。<br>\n' +
              '现状与难题：<br>\n' +
              '订单主要来自海外，为典型的“多品种小批量”型生产，加之客户交期较紧，企业通过大量的在制品库存应对需求，当接到订单，取在制品继续生产。经常遇到在制品生产完放置在一边后再找不到的情况。在制品问题直接导致积压企业大量的现金流。<br>\n' +
              '解决方案：<br>\n' +
              '对于很多制造业，尤其“多品种小批量”的企业，虽然生产的提前期可以满足订单交期，但往往在大批量生产时不能准时交货，问题出在在制品过多，物料“流不下去”。所以关键在于控制在制品，这需要记录在制品在现场中的动态信息。<br>\n' +
              '新核云为每一批在制品制定了唯一条码管理，无论在制品在车间还是在仓库都能在条码中记录在制品的位置。同时“数字化”了在制品，在生产排产时充分考虑在制品的数量和加工提前期，不做“浪费型生产”，减少在制品数量。<br>\n' +
              '设备数据采集方案<br>\n' +
              '<br>\n' +
              '解决方案详述<br>\n' +
              '· 通过主动和实时监控设备利用率，更快地响应设备异常。<br>\n' +
              '· 通过设备间的集成，将生产实时数据汇总到云端，建立算法模型分析。<br>\n' +
              '· 通过实时产量和次品跟踪，确保更高的效率，降低生产成本。<br>\n' +
              '· 预测性维护警报，降低生产事故，提升车间产能。通过对趋势数据的持续分析，利用随机森林算法，提前预知可能发生的生产异常。<br>\n' +
              '客户介绍：<br>\n' +
              '国内排名前五的某知名整车厂发动机部件供应部门，拥有近500名工人，5条自动化生产线，120多台日系机床与机器人，35台德系注塑机。车间内多为RS485、CAN、PROFIBUS设备。<br>\n' +
              '存在的问题：<br>\n' +
              '工厂运行的机床与机器人数量庞大，而车间内每名工人最多只能维护2~3台设备，存在维护不及时等诸多风险、这让拥有超过150台设备的客户无论在设备管理效率还是人力资金成本上都肩负着巨大压力。<br>\n' +
              '解决方案-C2s的设备数据采集：<br>\n' +
              '准确监测设备状态，减少不必要的人工检测，对存在风险的设备进行及时维护，高效应对设备实施管理的压力，减少人力成本。为解决客户迫切的需求，新核云为车间内每台设备装上了工业网关。该网关基于Modbus协议由新核云自主研发，可实时采集设备的运行数据，利用边缘计算技术在近源侧对数据进行预处理，将有价值数据上传至新核云端进行分析，自动报告详尽的生产数据，以此帮助工厂获得洞察，增加设备的维护效率和正常运行时间，减少人工，降低成本，确保输出高质量的产品。<br>\n' +
              '方案实施成果：<br>\n' +
              '一期实施过程中，客户主要关注设备异常状态、计划数量、实时产能、生产运行时间、计划运行时间、温度、负载等指标。因为有了主动的数据汇总，C2s能够帮助用户预知到潜在的异常风险，30多台设备的一个车间只需要3个人进行日常的维护。另外，设备稼动率OEE之前一直是人为估算的状态，使用C2s之后，OEE的计算也变得更加精准。项目实施上线后的3个月内，实时得到的OEE在65%左右，后续预计可达到80%以上。 “这彻底改变了我们中国制造的管理方式。”这是副厂长周先生在上线新核云C2s后的感言。<br>\n' +
              '新核云_排程解决方案<br>\n' +
              '<br>\n' +
              '解决方案简述<br>\n' +
              '聚合客户需求，分析能力资源负荷情况，制定出包括MPS、MRP、RCCP、CRP、DCP在内的完整且精准的优先级计划。<br>\n' +
              '解决方案详述<br>\n' +
              '横纵分级各项计划。纵向分成需求侧、供应侧和优先级计划。需求侧通过需求管理，汇总预测和客户订单，统一管理。供应侧通过能力计划看出每个资源未来的负荷情况。优先级计划用来平衡需求和供应，同时能力计划也可以验证优先级计划的可行性。横向分成主生产计划及对应的粗能力计划、物料需求计划及对应的能力需求计划和车间计划及对应的详情能力计划<br>\n' +
              '<br>\n' +
              '有限能力和能力计划验证。根据资源设定的能力，显示每个资源未来的负荷，对超出负荷部分支持延长工作时间或增加资源或修改生产时间解决。可视化显示资源负荷情况，减少订单延期风险。<br>\n' +
              '<br>\n' +
              '自动排产。按订单优先级、生产产品所需要的资源和资源能力，以及可选的排产规则自动排出生产计划。可选择的排产规则包括按交期倒排、最大化加工时间或最小化在制品数量等。智核云用户，可根据需求定制排产规则，通过甘特图直观显示自动排产的结果。<br>\n' +
              '<br>\n' +
              '客户介绍：<br>\n' +
              '某机械配件有限公司。公司占地面积60000平方米, 现有员工860人，主要从事汽车刹车盘、刹车毂等汽车零部件的生产和销售。目前，已经形成了年产500万件刹车盘、刹车毂的生产能力。近年来，公司在扩大国内市场的基础上，积极向海外发展，产品出口逐年增加，出口地区覆盖北美、南美及欧洲市场。<br>\n' +
              '现状及问题：<br>\n' +
              '不同的跟单员负责相应的客户。因缺少专业的PMC（生产及物料控制），回复客户交期与生产排期仅凭人为经验，缺乏可靠性。一旦发生设备停机或缺料等情况，需要一天甚至更长的时间重新调整计划。这也直接导致准时交货率只能维持在50%左右。<br>\n' +
              '新核云的解决方案：<br>\n' +
              '准时交货率低受两大因素影响。一方面是对需求侧客户订单和预测客户需求的聚合能力不足；另一方面是供应侧对自身能力资源的负荷情况缺乏准确判断。其中最为关键且最大的难题就是获取供应侧的能力资源负荷情况，这需要准确统计出每个产品在每个工序下的Cycle Time，对于一般的企业，此工作量非常巨大。<br>\n' +
              '新核云首先通过设备数据读取，收集每个产品的加工时间，帮助客户整理出基础数据，为获取资源负荷情况打下坚实的基础。再根据整理出的产品加工时间与能力进行自动排产，按优先级将任务派发到生产车间。生产车间所读取到的数控设备状态和加工数据，能自动汇总出任务的完成情况。如果遇到设备停机，一旦超过一定时间没有得到解决会自动向上层发送通知。<br>\n' +
              '新核云的排程方案在短时间内就将客户准时交货率从50%提升到了80%，且大大提升了排程计划的可靠性，带来了20%设备OEE的提升。<br>\n' +
              '新核云_质量管理解决方案<br>\n' +
              '<br>\n' +
              '解决方案简述<br>\n' +
              '提供完整的过程质量管理和来料质量管理，由质量管理员或技术指定质量规范，并由质量检验员执行并收集检验数据。检验数据定期汇总成为质量指标，并通过SPC分析出质量问题。<br>\n' +
              '解决方案详述<br>\n' +
              '质量规范。做为质量管理的基础数据，新核云提高细颗粒度的数据管理，支持维护每个物料的质量规范，每个规范中检验项支持计数型或计量型，并维护上下限和标准值。每个检验项还支持检验指导书的上传。<br>\n' +
              '过程检验数据收集。过程检验支持三种数据收集方式，自动化和数据收集准确程度会逐步提高。<br>\n' +
              '第一种，能通过手机APP，人工输入检验数据<br>\n' +
              '第二种，提供智能检具，能与新核云APP对接，直接传输检验数据<br>\n' +
              '第三种，与检验设备对接，读取检验设备中数据并记录。<br>\n' +
              '质量指标和SPC。过程检验通过一次性通过率（直通率）做为质量指标，并提供质量缺陷排列图和计数型、计量型控制图分析质量缺陷原因。根据检验数据定期统计出物料次品率，并在计算需求、采购和备料时根据次品率给出多余量。<br>\n' +
              '预测性。通过与检验设备对接后，能获取到实时准确的过程参数。通过机器学习分析出产生缺陷的过程参数变化趋势和模式。当再次发生缺陷的变化趋势时，能提前预警，防止次品产生。<br>\n' +
              '解决方案应用<br>\n' +
              '客户介绍：<br>\n' +
              '某弹簧有限公司为863国家高科技项目的重要供应商，是南京金城集团公司以及（德国）采埃孚汽车转向泵（南京）有限公司定期检验点生产厂家之一，也是德国西门子公司(大陆汽车电子)、美国福特公司和巴西马可波罗公司的合格供应商，是制造各种型号规格的拉簧、压簧、扭簧、夹簧的专业厂家。拥有世界先进的数控绕簧机、磨簧机、喷丸机、热处理炉等现代化弹簧生产设备150余台员工80余人。<br>\n' +
              '现状与问题：<br>\n' +
              '过程检验有纸质单据记录检验结果，客户对产品有追溯要求，所以纸质单据要存档5年以上，需要追溯时，要从成堆的文档里找出检验记录。虽然有检验记录，但检验的数据并没有利用起来做持续改进。对于制造企业，只记录未利用的数据也是一种巨大的浪费。<br>\n' +
              '当要做质量改进时，没有数据做支撑，多数情况靠经验。或者只有小部分数据加以利用做质量缺陷分析，太过片面，无法代表全局。<br>\n' +
              '解决方案：<br>\n' +
              '有检验设备的工序直接与检验设备对接，用检具检验的工序与智能检具连接，直接读取准确的实时数据。再将检验数据汇总成质量指标，实时监控过程检验。利用机器学习分析出产生缺陷的过程参数变化趋势和模式，当再次发生缺陷变化时，提前预警，停止次品继续生产。质量分析工具可以分析出具体质量问题，有针对性的进行改进，并重新确定质量目标。<br>\n' +
              '新核云_治工具管理方案<br>\n' +
              '<br>\n' +
              '解决方案详述<br>\n' +
              '· 工具列表及库存<br>\n' +
              '为每个工具定义周全的属性，包括唯一码，分类，描述，供应商，安全库存量，最小起订量等。<br>\n' +
              '库存管理工具的数量和仓位。<br>\n' +
              '使用条形码扫描来完成工具的出入库和移库。<br>\n' +
              '系统自动汇总在每个工具上执行的操作记录，生产状况和维护的详细日志。<br>\n' +
              '· 模具维护<br>\n' +
              '为每个模具（工具组）制定预防性维护计划。<br>\n' +
              '预置事件，例如“清洁”，“翻新”，“返工”等，每个事件都会提醒到用户。<br>\n' +
              '通过累计使用次数（由生产模块自动关联或手动关联）指定维修时间的频率。<br>\n' +
              '查看每个工具详细的维护历史记录。<br>\n' +
              '解决方案应用：<br>\n' +
              '客户介绍：<br>\n' +
              '某汽车通用部件机加厂成立于2001年，拥有近200名工人，70多台数控弹簧机，单机日产量2万件。工厂内部生产流转的成品近千种以上，每类成品都对应一组特定的刀具。<br>\n' +
              '存在的问题：<br>\n' +
              '工厂在车间管理上存在三大问题：<br>\n' +
              '1. 拿错刀，导致良品率下降；<br>\n' +
              '2. 现场刀具管控几乎是开放式状态，浪费严重；<br>\n' +
              '3. 设备和工具的维护全凭人为经验，成本管控不足。<br>\n' +
              '解决方案：<br>\n' +
              '1. 成品工艺路线中定义所需道具各类，道具台账管理一目了然。户提前维护好所有治工具的详细规格信息，并与成品工艺路线进行关联。每个工单下达生产时，系统可以准确建议所需要的刀具，防止用户出错。<br>\n' +
              '2. 条码管理，一一对应。<br>\n' +
              '该工厂对于工具的管理结束了开放式的无监控状态，部分工具上镭射条码，并对车间内的库位进行了更规范的编排；无法镭射条码的工具，通过挂上纸质条码标签；对于价格较低的工具选择手工维护。<br>\n' +
              '3. 治工具生命追踪更精确。<br>\n' +
              '设备和工具的维修保养有依据可寻，不再依靠经验判断。每一件成品的加工生产，新核云都会关联到唯一的设备和工具上。当用户在系统中维护设备的额定寿命后，系统在设备需要检修保养时会第一时间通知用户。<br>\n' +
              '方案实施成果：<br>\n' +
              '此方案实现了设备与刀具的台账实时更新，包括所在位置、寿命状态、分类等多种全面信息。条码管理方案让工厂最高月份的刀具使用成本从原本的20万降低至13万。全年节省50多万元工具采购成本。精确的治工具生命追踪为该客户提升了近10%的设备利用率。\n' +
              '\t</div>\n' +
              '</div>       \t\t\t\t\t\t</div>'},
          {ids:51,name:'生产制造执行管理系统',comp:'',logos:require('../../assets/img/yingyong/51-1.jpg'),issy:'',isxq:true,describe:'瑞熙生产制造执行管理系统，通过对企业生产过程的管控，提升企业效率，降低企业生产成本；',introduce: '<div class="content">\n' +
              '       \t\t\t\t\t\t<div class="detail-description-mod-content" style="color:#6F7479;font-family:-apple-system, &quot;font-size:14px;background-color:#FFFFFF;">\n' +
              '\t<div class="content-title" id="brightSpotTitle" style="font-size:16px;color:#252B3A;">\n' +
              '\t\t商品亮点\n' +
              '\t</div>\n' +
              '\t<ul class="brightSpot por-list por-list-circle" style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t<li id="brightSpot0" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t建立完善的质量体系：基于准确实时的数据采集和数理统计技术，通过关键指标预警及分析报表等实现质量管理目标。\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot1" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t搭建可配置的预警平台，通过消息自动实时推送，使得在正确的时间把正确的信息，以正确的方式传递给正确的人，提高协同效率。\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot2" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t全面集成采集设备运行数据，执行分析改善，提高设备稼动率与综合效率。\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot3" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t实现软件系统与实际业务深度结合，相互优化，深化手机工厂应用，引入可配置报表平台，进一步提升企业制造管理水平。\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot4" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t建立基于MES的高层决策支持平台，能够为企业高层提供“一站式”的决策信息支撑，通过各种常见的图表形象化、直观化、具体化的实时反映企业的运行状态、检测企业运营情况。\n' +
              '\t\t</li>\n' +
              '\t</ul>\n' +
              '</div>\n' +
              '<div class="detail-description-mod-content" style="color:#6F7479;font-family:-apple-system, &quot;font-size:14px;background-color:#FFFFFF;">\n' +
              '\t<div id="detail-description-desc-title" class="content-title" style="font-size:16px;color:#252B3A;">\n' +
              '\t\t商品说明\n' +
              '\t</div>\n' +
              '\t<table class="versionTable" style="margin:12px 0px 17px;">\n' +
              '\t\t<tbody>\n' +
              '\t\t\t<tr>\n' +
              '\t\t\t\t<td id="product-description-0">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">版本:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">V1.0</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t\t<td id="product-description-1">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">交付方式:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">License</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t</tr>\n' +
              '\t\t\t<tr>\n' +
              '\t\t\t\t<td id="product-description-2">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">适用于:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">Windows/Android/iOS</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t\t<td id="product-description-3">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">上架日期:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">2020-01-21</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t</tr>\n' +
              '\t\t\t<tr>\n' +
              '\t\t\t\t<td id="product-description-4">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">交付SLA:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">120 自然日</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t\t<td id="product-description-5">\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t</tr>\n' +
              '\t\t</tbody>\n' +
              '\t</table>\n' +
              '\t<div id="detail-description-desc" class="detail-description-desc" style="color:#666A75;">\n' +
              '\t\t一：MES系统功能模块<br>\n' +
              '1) 工厂建模：构建MES平台，完善系统运行所需的基础数据。<br>\n' +
              '2) 工艺建模：产品工艺流程管理、工艺要素配置，实现制程管控。<br>\n' +
              '3) 生产计划：建立工单、指令单，生产计划及派工、委外管理。<br>\n' +
              '4) 设备管理：设备履历建档，设备点检、维护保养等管理。<br>\n' +
              '5) 数据采集与管控：多远化方式采集生产过程数据。<br>\n' +
              '6) E-SOP管理：电子化设计图纸和工艺文件，支持终端自动推送、主动查阅。<br>\n' +
              '7) 品质管控：品质基础数据、检验规范建档，产品检验管理。<br>\n' +
              '8) 报表管理：定制化报表开发，提供生产、品质、绩效等数据的汇总及分析工具。<br>\n' +
              '9) 看板管理：在办公区域设立看板，实时监控制造过程。<br>\n' +
              '10) 手机APP管理：通过移动终端应用，使车间现场作业、消息传递、数据采集更加高效、方便、快捷。<br>\n' +
              '11) 接口管理：与PLM、ERP系统对接集成，获取静态及动态业务数据，并实时反馈执行情况。<br>\n' +
              '二：生产计划模块<br>\n' +
              '生产部接到客户订单后，在ERP进行物料需求计算（LRP）生成生产计划和采购计划。生产计划通过接口抛转至MES系统。车间管理人员根据生产计划结合MES系统实时采集的生产数据，派发生产任务给一线工人。调度编制生产计划时结合系统中生产数据，能提高生产计划可执行性和有效性，减少停工待料情形，提高生产效率。<br>\n' +
              '三：设备管理与数据采集<br>\n' +
              '车间老旧设备通过改造后，MES系统能采集设备开关机时间和零件加工实际时间，分析后可得出人员和机台综合效率（OEE）。系统还支持扫码枪、平板电脑和一体机等方式采集生产过程数据，实现生产过程产品物料、工艺、设备、人员和质量信息等信息正反向追溯，以及快速查看订单生产进度。<br>\n' +
              '四：E-SOP管理<br>\n' +
              '现场工人可用E-SOP功能读取正在加工的任务单的图纸和工艺文件，实现车间无纸化。这样节约图纸打印的纸张成本、减少调度人员复印图纸工作、增强技术文件保密性。<br>\n' +
              '五：检验管理<br>\n' +
              '系统实现多种品质数据采集，并可自动生成检验报告和品质分析表。生产过程出现品质异常，系统能自动产生相关异常单据跟踪品质异常。<br>\n' +
              '六：手机移动端关联<br>\n' +
              '手机移动端能方便、快捷的接收任务，随时随地的了解生产各环节参数指标，能够远程指挥和做出决策。<br>\n' +
              '七：看板管理<br>\n' +
              'MES系统采集的生产数据通过看板系统和分析系统可事实监控生产状态，并对现场异常提前预警，辅助管理决策。\n' +
              '\t</div>\n' +
              '</div>       \t\t\t\t\t\t</div>'},
          {ids:52,name:'可视化能源管理软件V1.0',comp:'',logos:require('../../assets/img/yingyong/52-1.jpg'),issy:'',isxq:true,describe:'能源成本是企业的重要成本构成之一！能源管理系统的建设不仅要解决能源浪费的问题，更要从能源消耗的视角综合分析生产过程要素的效率与协同性，提升精益化生产管控能力',introduce: '<div class="content">\n' +
              '       \t\t\t\t\t\t<p>\n' +
              '\t</p><p style="font-size:16px;color:#252B3A;">\n' +
              '\t\t商品亮点\n' +
              '\t</p>\n' +
              '\t<ul class="brightSpot por-list por-list-circle" style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t<li id="brightSpot0" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t十分钟管理，帮助管理者及时发现能源浪费的问题，一键式追踪问题所在位置、发生的时间、发生的原因以及相关的影响\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot1" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t闭环管理 ，第一时间把能效信息反馈给操作人员，让操作人员能够做到及时调整最优能效参数，及时处理异常防止能源浪费，真正为管理节能提供支 撑，将能效管理工作由事后统计变为事中管控\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot2" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t深挖业务，将能源管理与水泥生产管理业务深度结合，如启停机的能耗管理、峰谷平的生产调度，各操作岗位生产绩效等。成为企业能源管理不可缺少的业务工具\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot3" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t卡边操作，通过大数据分析明确最佳运行标准，不断优化操作模型。通过大量的运行数据，找出设备运行时所需要的最佳能耗标准作为能效考核依据， 推动能源绩效的持续改进\n' +
              '\t\t</li>\n' +
              '\t</ul>\n' +
              '<p></p>\n' +
              '<p>\n' +
              '\t</p><div id="detail-description-desc-title" class="content-title" style="font-size:16px;color:#252B3A;">\n' +
              '\t\t商品说明\n' +
              '\t</div>\n' +
              '\t<table class="versionTable" style="margin:12px 0px 17px;">\n' +
              '\t\t<tbody>\n' +
              '\t\t\t<tr>\n' +
              '\t\t\t\t<td id="product-description-0">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">版本:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">V5.0</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t\t<td id="product-description-1">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">交付方式:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">License</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t</tr>\n' +
              '\t\t\t<tr>\n' +
              '\t\t\t\t<td id="product-description-2">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">适用于:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">Windows</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t\t<td id="product-description-3">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">上架日期:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">2020-07-28</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t</tr>\n' +
              '\t\t\t<tr>\n' +
              '\t\t\t\t<td id="product-description-4">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">交付SLA:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">90 自然日</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t\t<td id="product-description-5">\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t</tr>\n' +
              '\t\t</tbody>\n' +
              '\t</table>\n' +
              '\t<p>\n' +
              '\t\t能源管理系统覆盖矿山石灰石破碎（石灰石输送、石灰石预均化）、矿山皮带输送、原料处理（辅助原料、原煤破碎及预均化）、原料粉磨、烧成系统、煤磨系统、水泥粉磨（含新建粉磨站）及包装系统等范围<br>\n' +
              '1． 规范系统建设标准<br>\n' +
              '通过该系统的建设，规范企业从计量仪表、数据采集、数据库分布、生产管理等方面的标准化管理。<br>\n' +
              '2． 实现精益化生产管理<br>\n' +
              '将生产、能耗、质量等相关数据自动采集后，按照管理人员分析问题的思维方式进行数据梳理和展示，帮助管理层及时高效获取数据，快速追溯问题根源，落实各级责任。<br>\n' +
              '3． 提高决策的科学性<br>\n' +
              '实现企业的精确监控管理，及时、准确、全面、系统地了解生产详情及能耗分布使用情况，科学分析各类生产问题，提高决策的科学性。<br>\n' +
              '4． 实现数字化考核<br>\n' +
              '系统的考核管理功能，对企业生产各环节进行诊断与分析实行目标值管理，建立完善的基于精益化管理的班组考核系统。结合在线问题追溯、异常报警、在线对标等手段，规范操作行为，降低产品能源成本。<br>\n' +
              '5． 促进可持续管理<br>\n' +
              '分析重点能耗设备的能源消耗过程，挖掘制定运行改善方案，对设备运行状态进行监测、核查，通过循环验证的方式实现水泥精细化、可持续管理目标。<br>\n' +
              '6． 为支撑智能工厂的建设提供支撑<br>\n' +
              '\t\t</p><p>\n' +
              '\t\t\t充分考虑系统的扩展性、接口标准、数据统一性等关键因素，为企业未来建设智能工厂提供数据支撑，同时打下良好的底层数据基础。\n' +
              '\t\t</p>\n' +
              '\t\t<p>\n' +
              '\t\t\t<br>\n' +
              '\t\t</p>\n' +
              '\t\t<p>\n' +
              '\t\t\t<br>\n' +
              '\t\t</p>\n' +
              '\t<p></p>\n' +
              '<p></p>       \t\t\t\t\t\t</div>'},
          {ids:53,name:'云生产系统',comp:'',logos:require('../../assets/img/yingyong/53-1.jpg'),issy:'',isxq:true,describe:'通过生产过程的防呆防错、追溯体系、品质管控、报表分析等生产全过程精益管理，使管理者能够即时准确的掌握工厂状况，帮助制造企业提质降本、增效减存，打造数字化工厂。',introduce: '<div class="content">\n' +
              '       \t\t\t\t\t\t<div class="detail-description-mod-content" style="color:#6F7479;font-family:-apple-system, &quot;font-size:14px;background-color:#FFFFFF;">\n' +
              '\t<div class="content-title" id="brightSpotTitle" style="font-size:16px;color:#252B3A;">\n' +
              '\t\t商品亮点\n' +
              '\t</div>\n' +
              '\t<ul class="brightSpot por-list por-list-circle" style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t<li id="brightSpot0" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t易——快速对接易上手 可基于现有的PC和移动端直接注册使用 操作简单，快速上手\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot1" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t省——云端部署省成本 云端租用灵活收费，硬件零投入 最大化节约企业投入成本\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot2" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t好——灵活适配多行业 适用于大部分行业，可根据需求定制开发，满足各行业的需求\n' +
              '\t\t</li>\n' +
              '\t</ul>\n' +
              '</div>\n' +
              '<div class="detail-description-mod-content" style="color:#6F7479;font-family:-apple-system, &quot;font-size:14px;background-color:#FFFFFF;">\n' +
              '\t<div id="detail-description-desc-title" class="content-title" style="font-size:16px;color:#252B3A;">\n' +
              '\t\t商品说明\n' +
              '\t</div>\n' +
              '\t<table class="versionTable" style="margin:12px 0px 17px;">\n' +
              '\t\t<tbody>\n' +
              '\t\t\t<tr>\n' +
              '\t\t\t\t<td id="product-description-0">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">版本:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">V1.0</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t\t<td id="product-description-1">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">交付方式:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">License</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t</tr>\n' +
              '\t\t\t<tr>\n' +
              '\t\t\t\t<td id="product-description-2">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">适用于:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">Windows/Android</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t\t<td id="product-description-3">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">上架日期:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">2020-12-03</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t</tr>\n' +
              '\t\t\t<tr>\n' +
              '\t\t\t\t<td id="product-description-4">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">交付SLA:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">40 自然日</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t\t<td id="product-description-5">\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t</tr>\n' +
              '\t\t</tbody>\n' +
              '\t</table>\n' +
              '\t<div id="detail-description-desc" class="detail-description-desc" style="color:#666A75;">\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t摩尔云生产系统是面向制造企业车间执行层的生产信息化管理系统。通过生产过程的防呆防错、追溯体系、品质管控、报表分析等生产全过程精益管理，使管理者能够即时准确的掌握工厂状况，帮助制造企业提质降本、增效减存，打造数字化工厂。广泛适用于SMT行业、电子组装行业、信息通讯、汽车装配、机械加工、新能源锂电池等生产制造企业。<br>\n' +
              '<br>\n' +
              '核心功能<br>\n' +
              '<br>\n' +
              '1、构建产销衔接、敏捷交付的计划体系<br>\n' +
              '结合计划开立生产任务工单；<br>\n' +
              '工单任务细分，精确到线体；<br>\n' +
              '任务随需调整，从容应对急单、插单；<br>\n' +
              '实时了解生产计划完成情况，掌控计划进度；<br>\n' +
              '提高计划执行率，精准供应、精准交付。<br>\n' +
              '<br>\n' +
              '2、敏捷生产 - 打造柔性多生产模式的工艺流程<br>\n' +
              '一站式设定工艺参数，可视化快速拖拽式；<br>\n' +
              '确保生产按工艺要求作业，减少工艺因素造成的不良；<br>\n' +
              '建立全流程防呆、防错，保障产品品质。<br>\n' +
              '<br>\n' +
              '3、质量预防 - 建立有效预防的质量控制计划和检验标准<br>\n' +
              '品质基础（抽样标准、检验标准）电子化、检验记录电子化、异常反馈实时化；<br>\n' +
              '品质分析智能化、便捷化、透明化；<br>\n' +
              '构建共享透明、差异化的品质防御体系。<br>\n' +
              '<br>\n' +
              '4、生产管理-生产全制程的闭环管控和防呆防错<br>\n' +
              '在制工单状况、工序生产状况，<br>\n' +
              '多维度、实时了解车间、线体、工序在制状况；<br>\n' +
              '实现透明化生产，减少在制；<br>\n' +
              '生产上料防错、生产状态防错、生产过程标识防错，确保制造执行有效性。<br>\n' +
              '<br>\n' +
              '5、设备管理-拦截有隐患设备、治工具投入生产<br>\n' +
              '设备、备品备件台帐系统化；<br>\n' +
              '跨终端作业，满足不同生产环境要求；<br>\n' +
              '主动抢单式维保模式和维修经验知识库；<br>\n' +
              '实现设备全生命周期管理，按需保养，有效保养，<br>\n' +
              '主动维保，提高员工积极性，绩效管理透明化。<br>\n' +
              '<br>\n' +
              '6、全面的追溯管理体系实现产品正反向追溯<br>\n' +
              '以条码化为载体，多样化数据采集方式，实现产品4M级正反向追溯管理体系；<br>\n' +
              '正向追溯：按产品SN追溯所使用的物料，制造工序，负责人员，使用设备及过程数据；<br>\n' +
              '反向追溯：按物料REEL ID追溯供应商、来料批次、投入订单、成品SN。<br>\n' +
              '<br>\n' +
              '7、构建多维、高效、协同的数据分析、决策平台<br>\n' +
              '提供各制造部门的现况/统计/KPI信息，构建实时共享现场信息体系，改变传统的员工作业驱动，使生产管理现场“透明化”。<br>\n' +
              '<br>\n' +
              '产品价值<br>\n' +
              '<br>\n' +
              '1、生产现场实时监控<br>\n' +
              '实时监控产品缺陷，生产进度、质量情况、设备状态，便于管理，支撑决策；<br>\n' +
              '<br>\n' +
              '2、有效的生产资源管理<br>\n' +
              '快速准确的了解生产资源（人、机、料、法、环），可以更有效的保障和提高生产资源的利用率；<br>\n' +
              '<br>\n' +
              '3、快速响应的预警平台<br>\n' +
              '通过系统数据规范化管理，可自行定义预警项目，生产、品质、设备等异常及时预警，降低异常响应时间；<br>\n' +
              '<br>\n' +
              '4、快速应对瞬息万变的市场<br>\n' +
              '实现快速转产，柔性调度，从容应对订单变更、插单等情况，保障订单按期交付；<br>\n' +
              '<br>\n' +
              '5、完善质量和产品追溯服务<br>\n' +
              '通过规范质检流程，产品合格率和质量稳定性提升。产品追溯准确，问题产品批量隔离；<br>\n' +
              '<br>\n' +
              '6、生产制造管理中心枢纽<br>\n' +
              '集成丰富的接口协议，整合多种接入方式，支持多平台、客户端、设备的融合。<br>\n' +
              '<br>\n' +
              '服务<br>\n' +
              '售前咨询→用户体验→现场调研→项目实施→知识共享→售后维护\n' +
              '\t\t</p>\n' +
              '\t</div>\n' +
              '</div>       \t\t\t\t\t\t</div>'},
          {ids:9,name:'巡检管理APP',comp:'',issy:'',isxq:'',describe:'基于supOS实现生产装置现场隐患排查，及时发现问题，通过移动端上报问题给supOS，统一分析处理'},
          {ids:19,name:'橡胶胶粒水浓度预测APP',comp:'',logos:require('../../assets/img/yingyong/19-1.jpg'),img:require('../../assets/img/yingyong/19.jpg'),issy:'',isxq:true,describe:'结合装置生产过程中的实时工艺参数、设备运行机理、人工操作经验等多维信息，提取关键数据特征、建立胶粒浓度预测模型，将训练与评估后的模型在实际装置上进行应用验证，进一步对模型在不同生产工况下的在线预测性能进行调优与评价',introduce:'卤化丁基橡胶在生产过程中，卤化反应时胶浆液浓度的控制是关键，浓度适当增加，产品收率会提高、综合能耗低；但浓度过高，会出现反应器结块，甚至生产事故。由于胶浆配比时胶粒水溶液的浓度无法用传感器测得，配比过程一般都靠有经验的操作工按经验，以及LIMS的化验数据进行人工配比，整个生产过程波动大、稳定性差，产品质量不可控。<br>\n' +
              '深度剖析卤化合成过程波动现象，结合装置生产过程中的实时工艺参数、设备运行机理、人工操作经验等多维信息，提取关键数据特征、建立胶粒浓度预测模型、择优选取回归分析与神经网络算法，将训练与评估后的模型在实际装置上进行应用验证，进一步对模型在不同生产工况下的在线预测性能进行调优与评价。<br>\n' +
              '模型投用后，目前实际胶粒水溶液流量17.64t/h（实际测量值），其中干胶流量6.88t/h（回归模型预测值），与化验测算对比误差0.05t/h，相对误差控制在1%以内，与之前的人工经验对比工艺平稳度大大提升。<br>\n'},
          {ids:10,name:'原油进厂管理APP',comp:'',issy:'',isxq:'',describe:'原油进厂登记,与管道公司调度APP数据联动，保证原油船舶进厂后，管道输送调度中心实时获取船舶信息，安排原油卸载'},
          {ids:11,name:'原料库存APP',comp:'',issy:'',isxq:'',describe:'利用移动端对油品库进行测量操作，实现原油、石脑油、乙烯原料、加氢原料、催化原料等库存量的定期盘点，为全厂日平衡做数据支撑'},
          {ids:12,name:'质量管理APP',comp:'',issy:'',isxq:'',describe:'根据产品生产过程，通过采集其样品质量数据，与生产工序、操作员进行关联；以图表形式展示主要指标及合格率（包含上下限），并可进行追溯查询。'},
          {ids:13,name:'生产装置APP',comp:'',issy:'',isxq:'',describe:'实现原料切换、投入产出量自动统计、发货量自动统计等功能。减少人工干预，保准数据正确性，提高操作人员效率'},
          {ids:14,name:'操作管理APP',comp:'',issy:'',isxq:'',describe:'实现面向企业的操作运行管理、班组操作规范化及操作安全管理，实现对操作指令的逐级下达，逐级确认，监控操作执行过程，分析操作偏差，量化评价班组操作水平，支持班组考核。'},
          {ids:15,name:'生产绩效统计APP',comp:'',issy:'',isxq:'',describe:'根据集团统一要求和各分厂实际需要定制出各类型的生产统计报表，形成生产管理所需的日报、周报、月报、季报、年报等。主要包括主要技术经济指标报表，产量、作业量报表，产品质量统计报等'},
          {ids:16,name:'能源管理APP',comp:'',issy:'',isxq:'',describe:'能源管理主要包括对能源消耗总量的控制和对单位产品能耗的监督，通过对能耗（电耗、煤耗）的数据采集、分析，找出能耗高、低的原因，并与行业标准进行对标'},
          {ids:20,name:'工艺流程APP',comp:'',issy:'',isxq:'',describe:'实现工艺流程图的统一监控，工艺参数信息关联穿透。'},
          {ids:21,name:'视频监控APP',comp:'',issy:'',isxq:'',describe:'与现有视频监控系统无缝对接，实现现场视频监控码流的统一浏览'},
        ]
      },
      {id:3,name:'设备管理',typeimg:require('../../assets/img/xzz-jbgl.jpg'),
        datas:[
          {ids:62,name:'智能印染系统',comp:'',logos:require('../../assets/img/yingyong/62-1.jpg'),img:require('../../assets/img/yingyong/62-2.jpg'),issy:true,isxq:true,url:'https://t.hangmindamei.com/largeScreen/index?u=QDERP013&p=123123',describe:'减少人工成本提高生产效率、提高产品质量和稳定性、降低能源和资源的使用量、减少中间环节，强化现场管理，安全水平高',introduce:''},
          {ids:22,name:'设备管理APP',comp:'',logos:require('../../assets/img/yingyong/22-1.jpg'),img:require('../../assets/img/yingyong/22.jpg'),issy:'',isxq:true,describe:'设备管理通过supOS工业操作系统，实现对全部的关键设备实现在线监测和远程诊断，对设备状况与绩效实现集中、全面、实时的可视化监控，实现设备从采购、质检、入库、出库、安装、运行监控、维修、直至报废的全生命周期管理和信息集成，规范设备管理业务与流程，实现设备的预知维修管理模式，减少装置非计划停车时间，降低维修费用。',introduce:'设备管理通过supOS工业操作系统，实现对全部的关键设备实现在线监测和远程诊断，对设备状况与绩效实现集中、全面、实时的可视化监控，实现设备从采购、质检、入库、出库、安装、运行监控、维修、直至报废的全生命周期管理和信息集成，规范设备管理业务与流程，实现设备的预知维修管理模式，减少装置非计划停车时间，降低维修费用。<br>\n' +
              '具体业务功能包括以下几项：<br>\n' +
              'a、设备资产管理——设备台帐管理模块是设备管理的基础模块，对全厂设备建立台帐、档案、处置等，主要包括设备编号、设备型号、设备名称、制造年月、设备原值、制造厂家、规格等静态信息，以及设备检修方案与执行记录、关键部件/备件更换记录、设备缺陷与消缺改造记录等动态信息。<br>\n' +
              'b、设备运行管理——按动、静、电、仪分为四大模块，体现设备运行结果，并进行运行状态分析和优化调整。<br>\n' +
              'c、设备健康管理——主要对设备运行状态进行监测、如静设备腐蚀管控、动设备振动监测、变频器运行监测等。<br>\n' +
              'd、设备维护管理——主要对全厂各类设备的维护维修、备品备件、维修工单、防腐改进等全程管理。<br>\n'},
          {ids:23,name:'设备综合管理软件',comp:'',logos:require('../../assets/img/yingyong/23-1.jpg'),issy:'',isxq:true,describe:'业务功能涵盖了项目前期、资产台帐管理、物资备件、故障管理、维护维修管理、分析报表及预警功能等',introduce: '<div class="content">\n' +
              '       \t\t\t\t\t\t<div class="detail-description-mod-content" style="color:#6F7479;font-family:-apple-system, &quot;font-size:14px;background-color:#FFFFFF;">\n' +
              '\t<div class="content-title" id="brightSpotTitle" style="font-size:16px;color:#252B3A;">\n' +
              '\t\t商品亮点\n' +
              '\t</div>\n' +
              '\t<ul class="brightSpot por-list por-list-circle" style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t<li id="brightSpot0" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t具备集团级的设备运维管控能力\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot1" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t核心业务支持移动式应用（微信/APP）\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot2" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t采用预防性和工单运维方式，实现了可配置的周期性预防运维预警\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot3" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t实现设备运维预警体系，包括保养预警、寿命预警、备件库存预警等\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot4" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t内置工作流引擎，支持可视化设备地理位置展现\n' +
              '\t\t</li>\n' +
              '\t</ul>\n' +
              '</div>\n' +
              '<div class="detail-description-mod-content" style="color:#6F7479;font-family:-apple-system, &quot;font-size:14px;background-color:#FFFFFF;">\n' +
              '\t<div id="detail-description-desc-title" class="content-title" style="font-size:16px;color:#252B3A;">\n' +
              '\t\t商品说明\n' +
              '\t</div>\n' +
              '\t<table class="versionTable" style="margin:12px 0px 17px;">\n' +
              '\t\t<tbody>\n' +
              '\t\t\t<tr>\n' +
              '\t\t\t\t<td id="product-description-0">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">版本:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">V1.0</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t\t<td id="product-description-1">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">交付方式:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">License</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t</tr>\n' +
              '\t\t\t<tr>\n' +
              '\t\t\t\t<td id="product-description-2">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">适用于:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">Windows</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t\t<td id="product-description-3">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">上架日期:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">2021-01-28</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t</tr>\n' +
              '\t\t\t<tr>\n' +
              '\t\t\t\t<td id="product-description-4">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">交付SLA:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">150 自然日</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t\t<td id="product-description-5">\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t</tr>\n' +
              '\t\t</tbody>\n' +
              '\t</table>\n' +
              '\t<div id="detail-description-desc" class="detail-description-desc" style="color:#666A75;">\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t<img alt="6.png" class="mce_image " id="image_images_mce_6" src="https://marketplace-res-cbc-cn.obs.cn-north-1.myhuaweicloud.com/app_temp/picture/image/20210126/765070d2-1c19-4fac-a5e6-54449e816b91/2101260302493299.png" style="width:1216px;">\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t?利用TPM管理理念，将设备管理各个方面的工作规范为一个体系，加强设备的标准化管理和动态管理，实时动态地反映公司现有设备的资产状况、性能状态、综合利用率以及设备的使用、调配、维护等信息；<br>\n' +
              '?实现一级保养、二级保养和状态检测等计划的自动生成，并提供备件更换预警功能；<br>\n' +
              '?跟踪设备运行的动态情况和全面生产管理的各种技术数据，自动生成各类报表和走势图。<br>\n' +
              '?从各个方面动态掌握设备的综合使用情况及其变化趋势，实现降低库存、降低制造成本，避免各类浪费，实现全面生产管理思想，提高管理水平。\n' +
              '\t\t</p>\n' +
              '\t</div>\n' +
              '</div>       \t\t\t\t\t\t</div>'},
          {ids:30,name:'C-5001大机组预测性维护APP',comp:'',logos:require('../../assets/img/yingyong/30-1.jpg'),img:require('../../assets/img/yingyong/30.jpg'),issy:'',isxq:true,describe:'基于supOS工业操作系统平台，利用机器学习算法与大机组运行机理集合，对轴振动、润滑油温度、轴位移、转速、压力、蒸汽流量、蒸汽压力、蒸汽温度以及振颤异常点进行相关性分析，提取关键影响因子，建立大数据预测性维护模型，实现C-5001大机组的健康运行实时监测。',introduce:'C-5001加氢循环氢大机组是加氢装置中最关键的动力设备，循环氢压缩机的运行可靠与否关系到加氢装置的正常运行。长期生产中经常会有出现主轴振颤异常，从而直接影响产品质量，甚至停机检修带来直接经济损失。目前现场是设定传感器报警阈值，当异常发生时进行报警。该方案存在严重滞后性，且对生产易产生不可逆影响。<br>\n' +
              '基于supOS工业操作系统平台，利用机器学习算法与大机组运行机理集合，对轴振动、润滑油温度、轴位移、转速、压力、蒸汽流量、蒸汽压力、蒸汽温度以及振颤异常点进行相关性分析，提取关键影响因子，建立大数据预测性维护模型，实现C-5001大机组的健康运行实时监测，通过设定异常报警规则，可实现提前30分钟进行故障预报。<br>\n'},
          {ids:24,name:'设备运行分析APP',comp:'',issy:'',isxq:'',describe:'通过采集石化企业的各套设备信息和运行参数，对每套设备运行状态进行分析，根据不同类型设备的运行参数和生产能力设定权重来制定设备健康指数，判定设备运行的健康情况。可根据公式计算出设备的实际效率和能耗情况，绘制性能曲线模型，生成分析报告。'},
          {ids:25,name:'设备故障诊断与预测APP',comp:'',issy:'',isxq:'',describe:'通过建立压缩机、汽轮机、电动机、变频器等运行故障模型，形成诊断对象和测量参数标准的数据结构，同时为案例检索提供索引机制；根据采集的设备运行参数信息，通过系统报警触发或人工触发两种方式，对设备故障进行诊断；建立故障诊断规则库和案例库，用于存储故障诊断知识，在发生类似事故时，自动推送诊断和预警信息。'},
          {ids:26,name:'专家诊断平台APP',comp:'',issy:'',isxq:'',describe:'作为石化企业重点设备故障诊断的一个重要手段，专家协助企业诊断故障原因，给出解决办法，为设备检修、运行提供支持。建立企业智能工厂设备专家诊断平台，以大型离心式机组、高压加氢反应器、电脱盐罐、变频设备的事故诊断为试点，整合专家资源、完善诊断流程、积累故障案例。'},
          {ids:27,name:'变频器管理APP',comp:'',issy:'',isxq:'',describe:'提供石化企业的变频器功率管理能力，通过传感器监测变频压机在开启时段电压、电流的变化情况，实时计算和记录的压缩机功率变化情况，并通过supOS系统及时反馈。'},
          {ids:28,name:'设备腐蚀诊断与评估APP',comp:'',issy:'',isxq:'',describe:'建立石化企业的静设备故障诊断功能，以高压加氢反应器、电脱盐罐、脱硫塔、加氢高压空冷器的腐蚀诊断为试点，协助石化企业设备管理、生产装置、运维检修等职能部门进行分析和诊断故障原因，给出解决办法，为设备检修、运行提供支持帮助。'},
          {ids:29,name:'设备维修保养管理APP',comp:'',issy:'',isxq:'',describe:'根据石化企业的设备维修保养制度，支持维保计划的线上导入，维保期限提前预警通知（用户可自定义维保预警时间），维护信息闭环管理（包含文档上传，信息备注等）；并基于特种设备和重要设施的维保记录，生成维保报表，包含维护保养实施率的实时计算功能。'},
        ]
      },
      {id:4,name:'安全环保',typeimg:require('../../assets/img/xzz-aqhb.jpg'),
        datas:[
          {ids:32,name:'安全生产预警预报APP',comp:'',logos:require('../../assets/img/yingyong/32-1.jpg'),img:require('../../assets/img/yingyong/32.jpg'),url:'/productionalarm?id=1',issy:true,isxq:true,describe:'全公司整体的安全运行状态，以及各车间的安全状态。在安全详情页面，系统还提供了年月日三个维度的数据统计、各指标的构成分析、横向各部门的比较、纵向同比、环比数据统计等工具，帮助分析安全风险和趋势。同时，supOS平台打通钉钉消息，一旦安全指标降低到警告或危险区域时，立即发送信息到安全管理员和相关领导，督促及时处理',introduce:'在炼油生产过程中，人的不安全行为、物的不安全状态以及管理上的缺陷都是危险源和隐患，对于重大危险源和隐患的辨识、评价、监控、预警也就成了安全生产工作中的中心任务。安全部门对于安全日常管理存在两个难点：一是安全数据来源很多，数据的收集和统计存在很大的难度；二是日常安全考核大多以月为周期，很难进一步落实到日，及时性差、不全面。很多隐患和风险平时未能及时解决。在某种程度上，使得日常安全管理流于形式。<br>\n' +
              '通过总结和提炼安全生产过程中的各种风险因数，构建了包含事件管理、隐患管理、工艺平稳率、重点设备运行、工艺报警、现场报警、作业安全和安全领导力等8个一级指标以及近30个二级指标的安全指标模型。根据不同的风险权重，从公司和车间两个维度为每个指标赋予不同的考核系数，经复杂的计算提炼，从而形成可视化、可对比、可执行、可预警的安全生产管理体系。<br>\n' +
              '通过安全生产预警预报APP，安全管理人员可以在首页一目了然地看到全公司整体的安全运行状态，以及各车间的安全状态。在安全详情页面，系统还提供了年月日三个维度的数据统计、各指标的构成分析、横向各部门的比较、纵向同比、环比数据统计等工具，帮助分析安全风险和趋势。同时，supOS平台打通钉钉消息，一旦安全指标降低到警告或危险区域时，立即发送信息到安全管理员和相关领导，督促及时处理。<br>\n'},
          {ids:54,name:'安全生产综合监管信息平台',comp:'',logos:require('../../assets/img/yingyong/54-1.jpg'),issy:'',isxq:true,describe:'安全生产综合监管信息平台是针对新形势下企业安全主题智能化、智慧化的改造和提升，是安全管理新思路、新体系的积极探索',introduce: '<div class="content">\n' +
              '       \t\t\t\t\t\t<div class="detail-description-mod-content" style="color:#6F7479;font-family:-apple-system, &quot;font-size:14px;background-color:#FFFFFF;">\n' +
              '\t<div class="content-title" id="brightSpotTitle" style="font-size:16px;color:#252B3A;">\n' +
              '\t\t商品亮点\n' +
              '\t</div>\n' +
              '\t<ul class="brightSpot por-list por-list-circle" style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t<li id="brightSpot0" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t对人的行为管控手段提升\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot1" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t对物（车辆）的状态管控落实强化\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot2" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t对环境的安全状况分析维度扩展\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot3" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t对组织管理的方式转变优化\n' +
              '\t\t</li>\n' +
              '\t</ul>\n' +
              '</div>\n' +
              '<div class="detail-description-mod-content" style="color:#6F7479;font-family:-apple-system, &quot;font-size:14px;background-color:#FFFFFF;">\n' +
              '\t<div id="detail-description-desc-title" class="content-title" style="font-size:16px;color:#252B3A;">\n' +
              '\t\t商品说明\n' +
              '\t</div>\n' +
              '\t<table class="versionTable" style="margin:12px 0px 17px;">\n' +
              '\t\t<tbody>\n' +
              '\t\t\t<tr>\n' +
              '\t\t\t\t<td id="product-description-0">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">版本:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">V1.0</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t\t<td id="product-description-1">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">交付方式:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">License</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t</tr>\n' +
              '\t\t\t<tr>\n' +
              '\t\t\t\t<td id="product-description-2">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">适用于:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">Windows/Android</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t\t<td id="product-description-3">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">上架日期:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">2021-04-13</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t</tr>\n' +
              '\t\t\t<tr>\n' +
              '\t\t\t\t<td id="product-description-4">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">交付SLA:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">120 自然日</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t\t<td id="product-description-5">\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t</tr>\n' +
              '\t\t</tbody>\n' +
              '\t</table>\n' +
              '\t<div id="detail-description-desc" class="detail-description-desc" style="color:#666A75;">\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t安全生产综合监管信息平台是针对新形势下矿山企业安全主题智能化、智慧化的改造和提升，是安全管理新思路、新体系的积极探索。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t智慧安全建设以“安全第一，预防为主，综合治理”为核心理念，对安全管理所覆盖的人-机-环-管等诸领域进行智能化、集成化管理体系建模与系统研发，在此基础上，以大数据平台数据治理体系为基础，深度利用大数据平台的数据集成、跨域融合等优势，通过数据深化应用、多维分析，将智慧管控融入安全管理日常业务，通过构建关联分析模型达到趋势预测的目的，推动安全管理由“事后处理”前移为“事前预警”、从被动应对到主动防控、从单一要素到精细协同的安全管理智能化目标。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t充分发挥数据价值，享用“数据福利”，利用数据为管理赋能，对重点、频发、高危事项差异化分级和精细化管控，打破传统安全管控模式，带来安全管控效能大幅提升和管控成本的大幅下降，推动三山岛金矿安全管理向智能化发展的转型。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t以先进技术为支撑，以创新思路为导向，以数据消费为最终目标，致力于将智慧管控融入安全管理日常业务，重点覆盖现场安全闭环治理、员工在线培训考试、下井车辆安全检查、作业地点安全状况分析、现场安全主题可视化分析等内容。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t利用信息化为手段推动安全管理水平提高，带来安全管控效能的提升和管控成本的下降，助推本质安全型矿山创建。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t安全平台通过大数据平台与其他业务平台数据互联互通，多维分析，并通过为领导提供决策依据实现数据消费。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t对人的行为管控手段提升\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t1.全员采集，构建全矿人脸资料库。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t人脸数据信息作为三山岛金矿重要数据资产，通过此次项目构建全矿统一的人脸数据库，涵盖三山岛金矿矿内在职人员及外委人员人脸数据。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t人脸资料库可以作为矿内人脸数据统一出口，为其他应用提供数据，避免重复采集。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t2.强化人脸识别应用，转变管理手段。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t推动人脸识别在日常管理中的应用。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t在培训过程中，采用人脸识别签到减少人工干预，规避代签、替签现象。视频学习中，穿插人脸验证，对学习质量进行约束。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t在下井人员身份验证环节，与下井口行人通道集成应用，控制未授权人员随意下井，对井下人员信息进行把控。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t●对物（车辆）的状态管控落实强化\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t1.强化车辆管控，保障作业安全。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t构建面向下井车辆安全确认，打通安全与物资部门对于车辆的安全状况检查数据，综合判断下井车辆安全状况是否合规。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t2.结合井口闸机，控制车辆放行。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t利用视觉识别技术与物联网技术，与井口闸机系统对接建设，获取车辆安全确认信息，针对问题车辆进行放行控制，让“数据说话”，杜绝车辆“带病作业”现象发生。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t●对环境的安全状况分析维度扩展\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t1.跨域数据打通，多维分析。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t利用大数据平台数据融合共享，打通智慧安全平台与自动化系统之间的信息壁垒，以“作业地点”主数据串联，实现安全管理数据与通风、排水等自动化数据聚合分析。&nbsp;\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t2.高危区域预警，抓好事前预防。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t对隐患进行地域性分析，结合BI可视化应用，建立作业地点隐患发生等级模型，提高安全管控针对性，实现差异化精准管控。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t●对组织管理的方式转变优化\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t1.隐患闭环流程全覆盖，强化事中监管。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t利用移动终端和离线应用，将信息化应用延伸至井下管理，实现隐患闭环全移动端覆盖，以扫码检查并上传现场图片的方式，有效规避“只巡不检”现象发生。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t辅助实时隐患数据展示，实现对隐患闭环的动态监管。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t2.强化履职考核，责任到岗。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t以问题为导向，以绩效考核为抓手，量化考核标准，明细奖惩依据，严格安全生产管理考核。通过履职考核，规范安全生产管理,着力提升工作执行力。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t3.BI可视分析，数据溯源。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t将海量数据实时动态展示，根据管控层级、职责需要定制不同界面，实现“一人一窗口，一人一大屏”，使数据运营价值发挥到最大，辅助业务洞察。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t4.培训总结，错什么补什么。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t通过总结考试成绩及高频错题分析，及时发现员工知识掌握不足之处，对培训有更深层的计划，改进培训方向，让培训组织更科学。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t●经济效益方面提升\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t1.优化培训组织安排，节约培训组织成本。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t线上培训考试模式，无需统筹参训人员上课时间，无需占用教学场地，规避生产作业时间与安全培训时间冲突情况。自动发卷，自动阅卷，大大减少培训组织成本。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t员工利用碎片时间自主学习，既满足安全培训要求，又保证生产任务，提高时间利用率。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t2.提高数据分析效率，降低数据准备成本。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t将各类分散的安全数据有效整合，归集重点数据推送管理者，为管理者决策分析提供依据，在提高数据真实性的基础上，又能很好的节省人力、时间成本。\n' +
              '\t\t</p>\n' +
              '\t</div>\n' +
              '</div>       \t\t\t\t\t\t</div>'},
          {ids:31,name:'安全工作管理APP',comp:'',issy:'',isxq:'',describe:'安全生产日常所需要进行的工作（安全通知通告、安全例会管理、安全检查管理、安全活动管理、检维修安全监控和安全文化管理）'},
          {ids:55,name:'安全生产信息化管理平台',comp:'',logos:require('../../assets/img/yingyong/55-1.jpg'),issy:'',isxq:true,describe:'安全生产信息化管理平台 安全生产信息化管理平台通过对信息采集、信息共享、风险监控、安全预警、应急指挥、决策支持一体化等管理，优化应急风险应急流程，降低高风险生产事故的发生概率，全面提升安全生产管理水平。',introduce: '<div class="content">\n' +
              '       \t\t\t\t\t\t<div class="detail-description-mod-content" style="color:#6F7479;font-family:-apple-system, &quot;font-size:14px;background-color:#FFFFFF;">\n' +
              '\t<div class="content-title" id="brightSpotTitle" style="font-size:16px;color:#252B3A;">\n' +
              '\t\t商品亮点\n' +
              '\t</div>\n' +
              '\t<ul class="brightSpot por-list por-list-circle" style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t<li id="brightSpot0" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t信息溯源，处理有序：安全生产信息化，原纸质，线下操作流程均 信息化，保存大量原始记录，可有效进行处 理、存档和调用\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot1" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t智能预警，全面掌控：实现动态监控管理、数据共享，实现企业安全信息全覆盖、全透明、全掌握；对员工进行工作提醒，实现智能预警；消息发送途径自由设置，实现全面跟踪提醒\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot2" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t智能统计分析，实现大数据管理：系统实现各业务数据自动统计分析，数据报表下载打印功能，实现安全生产大数据分析，管理，为管理决策提供依据\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot3" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t移动终端，随时随地展开工作：系统实现移动审批、移动隐患登记、移动事故快速上报、信息提醒、安全巡检等功能， 实时便捷，减少事故发生\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot4" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t台账智能管理，提高工作效率：安全管理台账、职业卫生台账等台账批量打印，提升效率。\n' +
              '\t\t</li>\n' +
              '\t</ul>\n' +
              '</div>\n' +
              '<div class="detail-description-mod-content" style="color:#6F7479;font-family:-apple-system, &quot;font-size:14px;background-color:#FFFFFF;">\n' +
              '\t<div id="detail-description-desc-title" class="content-title" style="font-size:16px;color:#252B3A;">\n' +
              '\t\t商品说明\n' +
              '\t</div>\n' +
              '\t<table class="versionTable" style="margin:12px 0px 17px;">\n' +
              '\t\t<tbody>\n' +
              '\t\t\t<tr>\n' +
              '\t\t\t\t<td id="product-description-0">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">版本:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">V3.3</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t\t<td id="product-description-1">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">交付方式:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">License</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t</tr>\n' +
              '\t\t\t<tr>\n' +
              '\t\t\t\t<td id="product-description-2">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">适用于:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">Windows/Android/iOS</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t\t<td id="product-description-3">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">上架日期:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">2020-08-03</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t</tr>\n' +
              '\t\t\t<tr>\n' +
              '\t\t\t\t<td id="product-description-4">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">交付SLA:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">30 自然日</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t\t<td id="product-description-5">\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t</tr>\n' +
              '\t\t</tbody>\n' +
              '\t</table>\n' +
              '\t<div id="detail-description-desc" class="detail-description-desc" style="color:#666A75;">\n' +
              '\t\t【商品详情】<br>\n' +
              '一朵云：搭建安全云计算体系，对计算、存储、网络等资源进行管理、提供大数据和云计算服务，显著提升整个企业的管理和服务能力，保障企业安全。<br>\n' +
              '一张图：基于空间信息和企业安全重点，整合安全监督、事故管理、作业安全、重大风险、隐患整改、应急资源等专题图，实现一张图可视化管理。<br>\n' +
              '多项举措：安全生产全流程管理，实现在线作业、在线监管、在线培训、在线审批、在线整改、在线监督等多项举措。<br>\n' +
              '多点监控：危险源实时监控、数据实时掌握、阈值在线预测提醒、多点监控、园区全覆盖、实现安全安全在线掌握。<br>\n' +
              '【核心功能】<br>\n' +
              '安全智能预警、风险预测管控、多媒体数字展厅、大数据智能分析、三位数字工厂、工艺管理优化<br>\n' +
              '【服务】<br>\n' +
              '1、专业的实施团队：<br>\n' +
              '重大事项方向决策；质量保障、进度保障、文档管理；业务需求支持、项目落地实现、保障客户成功和项目成功。<br>\n' +
              '2、完善的客户培训体制：<br>\n' +
              '概念讲解、系统初识：整体讲解系统涉及的专业概念、对于系统有初步认识，理解系统可以帮助解决什么问题。<br>\n' +
              '课堂培训、业务梳理：课堂式整体培训，结合真实业务，手把手教授系统使用方法，使系统联系业务，系统协助业务梳理，提高客户系统使用技巧。<br>\n' +
              '实操练习、稳扎稳打：课后作业，系统实际操作，通过真实的系统实地操作，了解系统，匹配业务。<br>\n' +
              '沙盘演练、模拟真实：业务主干根据客户实际业务，真实模拟重现 现场业务，匹配流程，完善业务，实现业务与系统的深度匹配，从而增强系统理解，提升使用效率。<br>\n' +
              '3、细致的售后运维服务体系：售后客服中心；一对一专属工程师；定期巡检、回访。\n' +
              '\t</div>\n' +
              '</div>       \t\t\t\t\t\t</div>'},
          {ids:56,name:'化工企业安全生产信息化管理平台',comp:'',logos:require('../../assets/img/yingyong/56-1.jpg'),issy:'',isxq:true,describe:'安元充分利用云计算、物联网、大数据等技术，结合自己多年的行业积累，研发了集风险分区、监测预警、生产人员在岗在位、安全生产全流程管理于一体的“化工企业安全生产信息化管理平台”。',introduce: '<div class="content">\n' +
              '       \t\t\t\t\t\t<div class="detail-description-mod-content" style="color:#6F7479;font-family:-apple-system, &quot;font-size:14px;background-color:#FFFFFF;">\n' +
              '\t<div class="content-title" id="brightSpotTitle" style="font-size:16px;color:#252B3A;">\n' +
              '\t\t商品亮点\n' +
              '\t</div>\n' +
              '\t<ul class="brightSpot por-list por-list-circle" style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t<li id="brightSpot0" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t1.覆盖要素全面：从风险的管控治理出发，覆盖企业安全生产管理全流程各个要素。\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot1" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t2.拥有丰富的移动端应用功能：支持APP内嵌的语音识别、定位、移动打印、蓝牙技术等特色功能。\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot2" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t3.内嵌专业、科学、领先的量化风险评估模型与算法。\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot3" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t4.建立风险预警能力：实时报警信息与企业固有风险指数关联建立模型，对整体生产安全状态进行预测预警。\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot4" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t5.提供精准、实时的人员位置信息：通过人-机协同加强员工的不安全行为管控和应急场景辅助。\n' +
              '\t\t</li>\n' +
              '\t</ul>\n' +
              '</div>\n' +
              '<div class="detail-description-mod-content" style="color:#6F7479;font-family:-apple-system, &quot;font-size:14px;background-color:#FFFFFF;">\n' +
              '\t<div id="detail-description-desc-title" class="content-title" style="font-size:16px;color:#252B3A;">\n' +
              '\t\t商品说明\n' +
              '\t</div>\n' +
              '\t<table class="versionTable" style="margin:12px 0px 17px;">\n' +
              '\t\t<tbody>\n' +
              '\t\t\t<tr>\n' +
              '\t\t\t\t<td id="product-description-0">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">版本:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">V1.0</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t\t<td id="product-description-1">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">交付方式:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">License</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t</tr>\n' +
              '\t\t\t<tr>\n' +
              '\t\t\t\t<td id="product-description-2">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">适用于:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">Windows/Linux/Android/iOS/其他</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t\t<td id="product-description-3">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">上架日期:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">2021-02-01</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t</tr>\n' +
              '\t\t\t<tr>\n' +
              '\t\t\t\t<td id="product-description-4">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">交付SLA:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">30 自然日</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t\t<td id="product-description-5">\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t</tr>\n' +
              '\t\t</tbody>\n' +
              '\t</table>\n' +
              '\t<div id="detail-description-desc" class="detail-description-desc" style="color:#666A75;">\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t“化工企业安全生产信息化管理平台”主要包含四大系统：重大危险源监测预警系统、企业安全风险分区管理系统、人员在岗在位管理系统、企业生产全流程管理系统。<br>\n' +
              '<br>\n' +
              '一、 重大危险源监测预警系统<br>\n' +
              '通过采集重大危险源储存设施及生产装置的实时数据和非实时数据并通过风险预警模型进行动态预警。实时数据包含：温度、压力、液位和报警信息、视频等，非实时数据包含包括化工企业基本信息，重大危险源储罐及装置信息（包括工艺指标限值）、物料详细信息等。<br>\n' +
              '（1）重大危险源信息管理<br>\n' +
              '包含涉及重大危险源的单元信息（储罐区、库区、生产单元）以及该单元涉及到的危险物质详细信息和储罐类型、个数、防火堤等信息，库房结构、火灾危险性等信息，生产单元的占地面积、生产原料等信息。<br>\n' +
              '（2）风险监测预警<br>\n' +
              '物联网设备将企业监测点位温度、压力、浓度等生产数据以及企业监控视频信息统一接入汇总推送至平台，可直接在平台调阅查看监测数据，监测数据超出报警阈值则会产生报警，通过对视频图像分析，进行人员离岗、火焰分析等视频报警，所有的数据监测报警和视频监控报警信息自动汇总报警中心，便于企业及时关注和管理自身的报警情况。<br>\n' +
              '（3）内嵌模型<br>\n' +
              '系统内嵌了”重大危险源辨识与分级模型”和“事故后果模型”。“事故后果模型”可视化模拟危险装置泄露后所造成的伤亡范围和财产损失范围，为预警分析提供参考依据。<br>\n' +
              '（4）可视化展示<br>\n' +
              '围绕重大危险源的实时报警监测和监控数据和罐区、库房、生产单元、监测设备的非实时数据，将该企业的重大危险源等级、危险单元详情、报警趋势分析、监测预警详情、报警信息管理等多维一体化展示，生成生产经营单位重大危险源看板。另外，可在企业平面图上可视化展示完整的重大危险源的分布情况，等级信息，实时数据监测（ 视频和传感器）及报警信息。<br>\n' +
              '<br>\n' +
              '二、 企业安全风险分区管理系统<br>\n' +
              '通过生产过程危险和有害因素的辨识，运用定性或定量，点、线、面相结合的风险评估方法确定其风险程度（重大风险、较大风险、一般风险、低风险），在系统中明确各个风险可能导致的后果，同时制定相对应的防范控制措施。系统根据风险分级管理的结果，将不同等级的风险点标示在总平面布置图上，实现企业安全生产风险分区分布 “一张图”可视化展示。<br>\n' +
              '（1）风险辨识、评估<br>\n' +
              '采用LEC、MES、PHA、HAZOP等风险辨识方法对风险点的危险有害因素、可能发生的事故类型进行风险辨识，根据点、线、面不同风险点类型，采用事故模拟分析、道化学火灾爆炸指数分析等不同的定量风险评估方法对企业风险点进行事故后果、财产损失、影响范围等量化评估与分级，实现企业固有风险的点、线、面三维一体化量化评估与分级。<br>\n' +
              '（2）风险管控<br>\n' +
              '针对“红、橙、黄、蓝”不同风险等级的风险点，系统建立风险闭环管控流程，实现“公司级、部门级、班组级、岗位级”四级风险管控主体责任落实及控制措施落实工作流程化和数字化管理。危化品企业的风险控制措施应从工程技术（或工程控制）措施、管理措施、培训教育、个体防护、应急处置 等方面识别并评估现有控制措施的有效性。现有控制措施不足以控制此项风险，应提出建议或改进的控制措施。结合PDCA循环，分级分类对每个风险点进行责任主体确认，控制措施有效落实 ，让风险点在日常安全管理中持续处于“受控”状态。<br>\n' +
              '（3）两单三卡信息管理<br>\n' +
              '系统可根据风险辨识、评估结果和风险闭环管控流程，自动生成风险清单和控制措施措施风险清单包含风险名称、、风险类别、风险等级、评估方法等信息。控制措施措施包含管控措施具体详情、管控等级和管控状态等信息。系统可对岗位风险告知卡、岗位应急处置卡、安全承诺卡进行管理。<br>\n' +
              '（4）可视化展示<br>\n' +
              '系统根据风险分级的结果，使用红、橙、黄、蓝四种颜色，将生产设施、作业场所等区域存在的不同等级风险标示在总平面布置图或地理坐标图上，实现企业安全生产风险分区分布 “一张图”可视化展示。<br>\n' +
              '<br>\n' +
              '三、 人员在岗在位管理系统<br>\n' +
              '可以实现基础信息管理、智能门禁管理、定位管理、告警管理、智能识别、实时告警、应急管理、查询分析等功能，能够及时、准确的将各个区域人员动态情况反映到系统中，使管理人员能够随时掌握生产人员的在岗在位信息，以便于进行更加合理的调度管理。当有紧急事故发生时，管理中心也可根据系统所提供的数据、图形，迅速了解有关人员的在岗在位信息，及时采取相应的救援措施，提高应急救援工作的效率。<br>\n' +
              '（1）三维全景监控，室内室外无缝切换<br>\n' +
              '系统兼容常见主流的三维模型格式，统一渲染成3D效果，支持360°旋转和自由缩放，同时支持在倾斜摄影技术航拍的3D模型上，无缝切换到3DMAX等工具构建的精细室内模型，通过全面的室内室外组合方案，为用户提供直观、真实、平滑、全方位的监控效果。<br>\n' +
              '（2）支持多种主流定位技术，为企业提供灵活可变的方案选择<br>\n' +
              '系统平台支持多种定位技术实现方式，包括成本事宜的蓝牙和Zigbee技术、厘米级定位精度的UWB 和技术、适用于开阔室外区域范围的GPS技术等，并提供对应的成套硬件配套设施，可以根据企业用户实际作业场景，如各套装置及罐区（含高层平台）、控制室、外操室、装车区等，再结合企业不同的信息化建设预算，进而实现随需配置，满足企业的多样性定位监控。<br>\n' +
              '（3）物联网设备集成管理<br>\n' +
              '系统平台支持有物联网设备及配套的无缝集成，结合有关人员的在岗在位信息，实现气体检测、液压检测等指标监控，同时联动视频监控、门禁一卡通（二道门）等自动化监管设施，可以有效提高应急响应速度和事件的处置速度，有效提高工厂的管理水平和管理效率。<br>\n' +
              '（4）灵活全面的自定义报警管控<br>\n' +
              '系统支持绘制不同类型的电子围栏，配置包括离岗报警、越界报警、超员报警、访客违规误入报警、滞留报警、危险区域报警等多种报警规则，全天候全方位监控各类区域，管控内部员工、临时访客、外协人员等多种人员。<br>\n' +
              '<br>\n' +
              '四、 企业生产全流程管理系统<br>\n' +
              '融合了化工企业安全生产标准化和化工企业过程安全管理要素的信息化管理系统，主要功能包括：企业基础数据管理、安全生产目标责任管理、安全制度管理、教育培训、风险分级管控与隐患排查治理、安全承诺公告、应急管理、事故管理、更管理、作业安全管理、法律法规辨识和安全知识库等。<br>\n' +
              '（1） 全面覆盖企业全流程管理各要素，建立统一的业务管理系统<br>\n' +
              '系统整合了《企业安全生产标准化基本规范》企业建设内容和《江苏省化工企业安全生产信息化管理平台建设基本要求》的信息化系统要求，实现了企业各安全管理要素的业务信息转化，通过建立统一的业务台账、工作在线办理和移动办公场景（巡检、隐患排查、在线学习、作业许可证审批签发等），帮助企业在满足合规要求基础下，同步完善规范自身安全管理工作，优化安全管理工作模式，改善企业安全管理绩效。<br>\n' +
              '（2）企业基础数据库建立，过期数据预警系统，工作场景便捷重造<br>\n' +
              '系统根据企业资质证书、人员证书和相关方证书、设备检维修保养信息建立预警时间线，便于企业管理人员及时规避人员和设备定期培训和检验的不合规风险。同时通过建立“一物一码”实现对于危险物品库存动态管理，“一设备一码”实现对于设备档案的有序移动化管理，便捷日常工作。<br>\n' +
              '（3）完善的教育培训系统，在线学习、考试、直播一应俱全<br>\n' +
              '在线教育学习系统帮助企业建立自主学习考试平台，能够同时满足企业对于年度培训计划制定实施跟踪、线上线下考试、在线学习人员素质提升、直播教学培训的多个使用场景的满足，同时移动端数据完全同步，实现员工随时随地在线学习答题参加培训的需求。企业还可建立企业培训讲师库，健全企业内训体系。<br>\n' +
              '（4）隐患排查治理实现企业设备巡检、隐患排查、5s现场管理三管齐下<br>\n' +
              '隐患排查治理系统围绕企业隐患排查信息化、移动化为中心，以服务企业为导向的理念进行设计，覆盖企业内部的隐患排查治理流程，辅助企业建立隐患排查点，提供丰富的检查表库，生成排查任务，解决企业隐患排查不到位的问题，配合移动终端开展隐患排查治理工作，使检查工作标准化、便捷化、高效化，对检查对象能够更全面、更专业、更科学。<br>\n' +
              '(5) 丰富的排查标准及安全检查实现排查规范化、标准化<br>\n' +
              '系统内嵌不同行业丰富的隐患排查标准及各类安全检查表，帮助企业建立检查标准库，为安全检查提供基础依据，让安全人员及员工知道查什么，怎么查，从而规范隐患排查的方式和方法，使检查工作标准化，对检查对象能够更全面、更专业、更科学。<br>\n' +
              '(6) 结合蓝牙、二维码、移动互联网等技术手段实现排查便捷化<br>\n' +
              '根据企业特点，划分隐患排查点，每个排查点对应一个二维码或绑定一个蓝牙设备，二维码/蓝牙设备中含盖排查点的排查要求、排查内容等相关信息。<br>\n' +
              '(7) 隐患随手拍实现全员化<br>\n' +
              '系统具有直接上报隐患的功能，此功能对企业所以人员都开放。除了安全检查人员外，其他在厂职工都能够随时填报自己身边发现的隐患，通过拍照的形式及时记录，并及时上报落实整改。真正做到了全员参与隐患排查工作，使公司隐患排查更加细致化。<br>\n' +
              '(8) 作业许可电子票证流转，现场手写签字，控制措施层层落实<br>\n' +
              '高危作业完整的闭环管理流程依据国标GB30871-2014的要求，规范高危作业执行过程，保障企业安全生产。内置符合标准的安全措施，减低安全风险。现场签票，责任到人，明确作业安全管理职责。<br>\n' +
              '(9) 建立责任体系，安全承诺公告实现数字层层研判自动统计<br>\n' +
              '严格依据《应急管理部安全生产风险研判和安全承诺公告管理制度的通知》（应急【2018】74号）要求搭建系统，实现了各层级向上自动汇总数据，企业承诺公告发布。系统可实现与在线显示屏数据同步对接，真正细化企业安全承诺公告，实现层层研判层层承诺，一级向一级承诺负责。<br>\n' +
              '(10) 丰富的安全知识库方便企业日常查询使用<br>\n' +
              '安全生产知识库中提供了日常业务管理过程中需要的内容知识，包括法律、法规、规章、标准、事故案例、MSDS等。<br>\n' +
              '(11) 应急管理电子组件化，建立企业应急响应中心，实现应急常态化、保障化管理\n' +
              '\t\t</p>\n' +
              '\t</div>\n' +
              '</div>       \t\t\t\t\t\t</div>'},
          {ids:33,name:'生态环境物联网AI监测监管系统',comp:'',logos:require('../../assets/img/yingyong/33-1.jpg'),issy:'',isxq:true,describe:'生态环境物联网AI监测监管系统是依托物联网、大数据、AI、区块链等先进信息技术建设的生态环境一体化监测监管平台，实时给出动态管控建议措施，真正做到智慧环保。',introduce: '<div class="content">\n' +
              '       \t\t\t\t\t\t<div class="detail-description-mod-content" style="color:#6F7479;font-family:-apple-system, &quot;font-size:14px;background-color:#FFFFFF;">\n' +
              '\t<div class="content-title" id="brightSpotTitle" style="font-size:16px;color:#252B3A;">\n' +
              '\t\t商品亮点\n' +
              '\t</div>\n' +
              '\t<ul class="brightSpot por-list por-list-circle" style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t<li id="brightSpot0" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t1. 多数据源的大气全景展示; 科学专业的污染分析\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot1" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t2. 高密度广区域的微站实时监测，微站分钟数据，及时响应报警，快速的洞察能力\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot2" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t3. 动态管控，以事件为基准的多维分析，AI溯源，从根本的了解污染问题\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot3" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t4. 事件的派发机制，现场的及时处理，全链路的闭环事件跟踪\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot4" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t5. 动态绩效，围绕考核目标的实时跟踪\n' +
              '\t\t</li>\n' +
              '\t</ul>\n' +
              '</div>\n' +
              '<div class="detail-description-mod-content" style="color:#6F7479;font-family:-apple-system, &quot;font-size:14px;background-color:#FFFFFF;">\n' +
              '\t<div id="detail-description-desc-title" class="content-title" style="font-size:16px;color:#252B3A;">\n' +
              '\t\t商品说明\n' +
              '\t</div>\n' +
              '\t<table class="versionTable" style="margin:12px 0px 17px;">\n' +
              '\t\t<tbody>\n' +
              '\t\t\t<tr>\n' +
              '\t\t\t\t<td id="product-description-0">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">版本:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">V1.0</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t\t<td id="product-description-1">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">交付方式:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">License</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t</tr>\n' +
              '\t\t\t<tr>\n' +
              '\t\t\t\t<td id="product-description-2">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">适用于:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">Windows/Linux/Unix/iOS</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t\t<td id="product-description-3">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">上架日期:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">2020-02-19</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t</tr>\n' +
              '\t\t\t<tr>\n' +
              '\t\t\t\t<td id="product-description-4">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">交付SLA:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">15 自然日</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t\t<td id="product-description-5">\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t</tr>\n' +
              '\t\t</tbody>\n' +
              '\t</table>\n' +
              '\t<div id="detail-description-desc" class="detail-description-desc" style="color:#666A75;">\n' +
              '\t\t生态环境物联网AI监测监管系统是依托物联网、大数据、AI、区块链等先进信息技术建设的生态环境一体化监测监管平台，实现大气、水环境、噪音、固废等生态环境信息的快速采集、海量存储、数据融合、深度挖掘、溯源预测等智能环境分析，整合监测数据和业务数据并结合算法模型找到污染根本，实时给出动态管控建议措施，有效管理生态环境的同时，解决了过去对排污企业“一刀切”的管理模式，真正做到智慧环保。<br>\n' +
              '通过对多源数据的融合分析，实现全市范围内的整体调度运营。通过大数据分析研判，进行整体调度运营。增加大数据分析模块及数据分析模型，结合专家分析服务，通过软件模块实现直观展示，快速响应、迅速派单、及时反馈等。增加联防联控及动态管控的发布模块，采用“周调度、日调节”的模式。“周调度”是指根据未来一周的天气和污染情况的预报预测，对重点管控的企业进行定时限产，以达到错峰生产，降低污染影响的目的。通过平台的污染源在线实时数据和微观站实时数据的分析比对，对施行限产的企业进全时段监控，对未执行限产，违规生产的企业，进行报警，并将报警信息推送至主管单位。必要时采取处罚或停产的管控措施。“日调节”是指每天根据气象状况，对重点区域上风向的企业、工地等污染源进行实时排查，发现环境问题，实时推送至责任单位，限时办结，必要时采取限产或停产的管控措施。“周调度、日调节”模式的有效运行，是系统的核心。<br>\n' +
              '其他功能还包括：一周一排名，一周发布一次企业错峰生产时间和排放标准；一周公布一次限号限行区域；每天发布第二天施工工地启停时间；绩效考核，对与重点管控的企业，以及参与到管理的相关单位都进行绩效考核，考核企业的合规生产，考核主管单位的处置率和办结率。<br>\n' +
              '<br>\n' +
              '疫情防控AI监控预警分析服务v1.0： 利用AI视觉模型公共场所、重点区域、人群聚集地进行安全隐患的检测，对疫情期间未佩戴口罩人群、人群危险聚集进行监控预警，对重点人群进行重点监控。本服务涉及到的AI模型识别正确率为99.0%，具有上百路同时处理的能力，秒级内时效响应<br>\n' +
              '注意：<br>\n' +
              '1. 前100名仅限免费接入 1路 摄像头。<br>\n' +
              '2. 购买成功表示同意并接受《疫情防控AI监控预警分析服务 免责申明》。<br>\n' +
              '<br>\n' +
              '生态环境物联网AI监测监管系统V1.0： 生态环境物联网AI监测监管系统是一个将智慧环保和大数据综合应用到领导决策层面的平台，平台主要建设一个管理者的驾驶舱，紧紧围绕智慧化应用和大数据挖掘，为管理者提供全方位的决策支持。<br>\n' +
              '<br>\n' +
              '生态环境AI大数据平台V1.0： 生态环境AI大数据平台能够通过运用视频等数据信息，运用AI技术对多种环保事件等重要目标进行捕获，准确识别多种环保行为，经对所识别的事件进行分析，自动预警，并自动生成污染事件报告。<br>\n' +
              '1. 工地雾炮车工作状态识别模型: 检测工地的雾炮车是否处于作业状态<br>\n' +
              '2. 工地雾炮车检测模型: 检测工地上的车辆是否是雾炮车<br>\n' +
              '3. 污水偷排检测模型: 检测工厂的排水管是否有偷拍污水<br>\n' +
              '4. 道路垃圾模型: 检测道路上是否有垃圾<br>\n' +
              '5. 车辆偷排模型: 检测河道边，是否有车辆偷排垃圾到河道<br>\n' +
              '6. 工地出入口车辆冲洗模型: 检测工地出入口的车辆，是否有进行冲洗<br>\n' +
              '7. 渣土车是否盖盖与载货模型: 检测渣土车是否有进行苫盖，是否有载货<br>\n' +
              '8. 渣土车检测模型: 检测抓拍到的车辆是否是渣土车<br>\n' +
              '9. 黑烟车检测模型: 检测抓拍到的车辆排气管尾气是否超标，排除的尾气颜色跟林格曼黑度的对比以进行黑度检测<br>\n' +
              '10. 塔吊喷淋模型: 检测工地的塔吊喷淋设施是否有按时进行喷淋作业<br>\n' +
              '11. 车牌识别模型: 检测抓拍到的车辆的车牌号<br>\n' +
              '12. 裸土检测模型: 对没有苫盖的裸露土地进行检测报警<br>\n' +
              '13. 扬尘检测模型: 对路面扬起的尘土以及环境中扬起的尘土进行检测<br>\n' +
              '14. 烟火检测模型: 检测环境中的烟雾、火焰，检测是否有无组织燃烧、明火燃烧<br>\n' +
              '15. 环保AI卡车检测模型: 检测卡口抓拍到的车辆的类型，重型、中型还是小型等<br>\n' +
              '16. 河道垃圾漂浮物模型: 检测河面是否有垃圾<br>\n' +
              '17. 工地货物堆积检测模型: 检测工地是否有货物堆积<br>\n' +
              '18. 电厂脱硫脱硝优化模型: 通过对电厂脱硫脱硝的过程数据深度学习以进行生产优化，以最少的物耗和能耗达到最好的脱硫脱硝效果<br>\n' +
              '19. 污染动态管控模型: 根据气象数据及污染源的排放情况，及近期一段时间污染情况和未来的污染预测，给出动态管控措施，具体到路段、某一区域及具体污染源。通过计算模型，实现动态管控的相关措施任务，以及管理。<br>\n' +
              '20. 空气质量预测模型: 通过历史污染物浓度和气象数据及历史空气质量情况，道路交通及地形情况进行空气质量预测预报。包含了预测预报模型及相关功能。<br>\n' +
              '21. 污染溯源模型: 建立算法模型，分析得出区域各污染来源贡献度。<br>\n' +
              '22. 物体移动检测模型: 检测特定物体是否有位移，一旦移动则进行报警<br>\n' +
              '23. 行人检测(入侵检测)模型: 检测特定边界范围内，是否有人越界入侵<br>\n' +
              '24. 是否吸烟模型: 检测是否有人吸烟<br>\n' +
              '25. 是否戴安全帽模型: 检测需要佩戴安全帽的特定环境中，进入的人是否佩戴安全帽<br>\n' +
              '<br>\n' +
              '生态环境物联网平台[简称：车载系统]V1.0： 使用移动车辆搭载环境监测设备对城市空气质量进行移动监测，为市、区、县级环保局工作人员排查与建筑、交通、餐饮、燃煤等城市活动有关的污染源提供帮助，实现主城区内小空间尺度污染热点区域的精细化管理，具有成本低、空间分辨能力强、灵活度高等特点。<br>\n' +
              '<br>\n' +
              '餐饮企业油烟在线监测系统V1.0： 将油烟净化设备工况数据与油烟浓度排放数据统一起来，实现感知监测、分析、统计、运维服务、油烟监管的全过程管理，为环保局和企业提供真实有效的油烟排放数据监测。<br>\n' +
              '<br>\n' +
              '环境应急预警管理系统V1.0： 突发环境事件呈多发态势，危险废物监管工作难度较大，通过环境应急指挥调度系统，利用信息化手段实现对环境突发事件的多部门联动、快速处置。<br>\n' +
              '<br>\n' +
              '化学工业区环境综合监管系统V1.0： 针对化学工业园区环境管理和环境风险防控职能，形成能够满足园区多目标（环境管理—环境预警）、多维度（园区—企业）、全生命周期（事前预防—事中处置—事后评估）的智能监管系统。<br>\n' +
              '<br>\n' +
              '监察一体化平台V1.0： 监察一体化平台以环境污染源管理为主，为环境监察执法提供信息化平台，提高执法效率。<br>\n' +
              '<br>\n' +
              '机动车尾气检测综合管理业务平台系统V1.0： 机动车尾气检测综合管理业务平台系统可完成对机动车尾气排放检测信息的统计及多维度分析，实现线上、线下有机结合。<br>\n' +
              '<br>\n' +
              '智慧环保V1.0： 智慧环保主要包含三个部分的内容，即环保数据中心、监测监控一体化、决策支撑平台，通过三部分内容的建设，实现环境监管精准化，从而提高环境保护宏观调控的能力。<br>\n' +
              '<br>\n' +
              '环境信息数据中心系统V1.0： 环境数据中心提供一企一档管理系统、环保标准管理系统、环保法律法规系统各一套，为生态环境决策提供数据支撑。<br>\n' +
              '<br>\n' +
              '大气网格化精准监测系统V1.0： 本平台采用“网格化布点+多元数据融合+时空数据分析”的模式，以网格形式布设监测点，用以获取实时大气污染物浓度数据，实现大气污染物在空间、时间上信息自动生成。<br>\n' +
              '<br>\n' +
              '大气网格化精细监管系统V1.0： 一套可实现污染源全掌握、网格员全覆盖、管理机构全登记、工作情况全留痕、绩效考核全量化和“发现问题-解决问题”的闭环操作系统。<br>\n' +
              '<br>\n' +
              '智慧水环境监测监管系统V1.0： 建立水环境综合监测监管体系，在环境监测手段上，实现由“单一、离散的站点监测”到“多源融合、三维立体的大数据监测”的创新与转变，实现水环境质量监测与智能分析一体化，在环境管理手段上，以水质达标重点区域为抓手，抓住污染防治的“关键少数”进行重点监管，建立“动态识别——评估考核——报警执法——整改退出”的闭环长效管理机制；<br>\n' +
              '<br>\n' +
              '企业污染源在线监测系统V1.0： 系统主要用于实现全天候在线监控重点污染源企业污染物排放情况及污染治理设施运行情况，包括污染源自动监控及污染源报警，实现污染源远程监测、数据采集、数据传输、自动判断是否超标。<br>\n' +
              '<br>\n' +
              '企业环保物联网系统V1.0： 系统实现对企业核心生产环节与污染治理设备用电信息的实时数据采集，建立用电与生产环节、治理环节的关联关系，实时检测出生产和治污运行异常信息，实时监控现场端运行状态。<br>\n' +
              '<br>\n' +
              '固废危废管理系统V1.0： 废物处理过程跟踪系统利用先进的物联网技术实现了对固体废物、医疗废物和放射源的闭环管理。\n' +
              '\t</div>\n' +
              '</div>       \t\t\t\t\t\t</div>'},
          {ids:34,name:'安全问题提报APP',comp:'',issy:'',isxq:'',describe:'实现石化企业安全问题提报的问题处理、专业问题库管理，落实安全整改责任人和责任部门，实现安全行为、安全巡查、员工奖励和承包商违章等动态监管。'},
          {ids:35,name:'特种作业安全管理APP',comp:'',issy:'',isxq:'',describe:'对石化现场高风险作业开展信息化管控，实施动火、动土、密闭容器作业等特种作业许可证在线办理，实现特种作业备案、入场（厂）、可燃气体分析、氧含量分析等安全措施落实检查、票证签发、作业过程、验收归档等节点的全过程安全管控。'},
          {ids:36,name:'环保管理APP',comp:'',issy:'',isxq:'',describe:'环保日常所需要进行的各项工作进行管理，包括环保会议、环保监测整改通知书、环保项目管理、环保投入、时间管理、排污费用管理等方面'},
          {ids:37,name:'危化品管理',comp:'',issy:'',isxq:'',describe:'在线管理危化品基础信息、理化性质、危化品分类，上传MSDS文件等，同时，用户可在线登记危化品领用情况。支持危化品管理、危化品厂家管理、危化品分类管理，实现危化品基础信息维护、危化品MSDS电子阅览、危化品使用登记等功能。'},
          {ids:38,name:'安全教育培训APP',comp:'',issy:'',isxq:'',describe:'建立企业典型的培训资料数据库、考试题库，与事故案例库和法律法规及制度管理库关联，能调取事故案例库和法律法规及制度管理库的资料，可进行在线培训、学习，并能进行培训记录及学时统计。'},
          {ids:39,name:'环境在线监测APP',comp:'',issy:'',isxq:'',describe:'通过石化企业的污染物排放口在线监测数据通过直传，实现石化企业内控监测点监测数据的实时监控、超标报警及趋势分析；实现对现场端设备有效性审核、监测点停运台账及凭证管理。'},
          {ids:40,name:'企业排放总量监测APP',comp:'',issy:'',isxq:'',describe:'实现石油化工、芳烃聚酯、橡胶、沥青等生产企业年度监测计划编制、发布和监测执行的全过程管理。集成LIMS监测数据，实现环境监测数据的登记、浏览、分析功能。'},
        ]
      },
      {id:5,name:'应急救援指挥',typeimg:require('../../assets/img/xzz-yjjyzh.jpg'),
        datas:[
          {ids:41,name:'应急救援管理APP',comp:'',issy:'',isxq:'',describe:'提供石化企业、化工园区的应急预案、应急演练、应急队伍、应急物资、应急演练评估、预案评估、预案总部备案功能，作为应急指挥系统的基础数据支撑，并与调度指挥结合，实现应急救援和事故处置的一体化管理。'},
          {ids:42,name:'应急救援一张图APP',comp:'',issy:'',isxq:'',describe:'在一张总图上集中展示应急救援物资、应急救援人员、污染物扩散面积等数据信息，为公司主要领导在应对着火爆炸等严重事故时，提供掌控全局的信息总图。'},
          {ids:43,name:'应急救援协同APP',comp:'',issy:'',isxq:'',describe:'发生着火爆炸等严重事故时，应急救援指挥体系要与政府主管部门、消防救援部门、卫生医疗部门等外围单位，进行信息交流和无缝衔接。'},
        ]
      },
      {id:6,name:'公共管理',typeimg:require('../../assets/img/xzz-gggl.jpg'),
        datas:[
          {ids:57,name:'公共消防安全智慧管理大数据云平台',comp:'',logos:require('../../assets/img/yingyong/57-1.jpg'),issy:'',isxq:true,describe:'我们向客户提供可定制、可升级的城市公共消防安全可视化管理服务，城市公共消防安全智慧管理云平台的建设和运维服务。同时面向客户我们提供消防风险评估、消防升级改造和消防维保等服务。',introduce: '<div class="content">\n' +
              '       \t\t\t\t\t\t<div class="detail-description-mod-content" style="color:#6F7479;font-family:-apple-system, &quot;font-size:14px;background-color:#FFFFFF;">\n' +
              '\t<div class="content-title" id="brightSpotTitle" style="font-size:16px;color:#252B3A;">\n' +
              '\t\t商品亮点\n' +
              '\t</div>\n' +
              '\t<ul class="brightSpot por-list por-list-circle" style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t<li id="brightSpot0" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t聚集人之智慧，赋予物以智能\n' +
              '\t\t</li>\n' +
              '\t</ul>\n' +
              '</div>\n' +
              '<div class="detail-description-mod-content" style="color:#6F7479;font-family:-apple-system, &quot;font-size:14px;background-color:#FFFFFF;">\n' +
              '\t<div id="detail-description-desc-title" class="content-title" style="font-size:16px;color:#252B3A;">\n' +
              '\t\t商品说明\n' +
              '\t</div>\n' +
              '\t<table class="versionTable" style="margin:12px 0px 17px;">\n' +
              '\t\t<tbody>\n' +
              '\t\t\t<tr>\n' +
              '\t\t\t\t<td id="product-description-0">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">版本:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">V1.0</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t\t<td id="product-description-1">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">交付方式:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">人工服务</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t</tr>\n' +
              '\t\t\t<tr>\n' +
              '\t\t\t\t<td id="product-description-2">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">适用于:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">Windows</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t\t<td id="product-description-3">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">上架日期:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">2020-03-16</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t</tr>\n' +
              '\t\t\t<tr>\n' +
              '\t\t\t\t<td id="product-description-4">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">交付SLA:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">90 自然日</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t\t<td id="product-description-5">\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t</tr>\n' +
              '\t\t</tbody>\n' +
              '\t</table>\n' +
              '\t<div id="detail-description-desc" class="detail-description-desc" style="color:#666A75;">\n' +
              '\t\t公共消防安全智慧管理大数据云平台服务是面向用户提供城市公共消防安全智慧管理大数据云平台建设服务、城市公共消防安全智慧管理大数据云平台运维服务、消防安全风险评估服务、消防安全升级改造服务、消防安全培训服务和消防维保服务。<br>\n' +
              '<br>\n' +
              '1. 城市公共消防安全智慧管理大数据云平台建设服务<br>\n' +
              '1.1. 平台部署安装服务<br>\n' +
              '我们为用户所在城市提供公共消防安全智慧管理大数据云平台软件及硬件的部署与安装服务。<br>\n' +
              '<br>\n' +
              '1.2. 信息化产品（软、硬件产品）开发及升级服务<br>\n' +
              '为满足用户使用需求，我们为用户提供其他公共消防安全相关信息化产品开发服务。在用户日常使用中，我们也提供信息化产品的升级服务。<br>\n' +
              '<br>\n' +
              '1.3. 消防工程设计及施工服务<br>\n' +
              '针对用户需求，我们提供消防工程设计及施工服务。服务范围包含消火栓系统、火灾自动报警系统、灭火系统（自动喷淋灭火系统、气体灭火所系）、电气火灾系统、防火卷帘门、防火门控制系统、防烟排烟系统等。<br>\n' +
              '<br>\n' +
              '2. 城市公共消防安全智慧管理大数据云平台运维服务<br>\n' +
              '我们提供城市公共消防安全智慧管理大数据云平台运营服务、故障排查服务以及事件处理服务（设备故障处理、平台故障处理、企业火灾协助处理）。<br>\n' +
              '<br>\n' +
              '3. 消防安全风险评估服务<br>\n' +
              '我们向用户提供消防安全风险评估服务。依据国家消防法律、法规、规范、标准，运用火灾安全工程学原理进行的定性或定量的评价分析，针对用户单位消防安全状况得出一个较为全面的量化结果。<br>\n' +
              '<br>\n' +
              '4. 消防安全升级改造服务<br>\n' +
              '我们向用户单位提供现有消防安全升级改造服务。服务范围包含企业消防设施、消防安全管理制度、消防安全管理人员等。<br>\n' +
              '<br>\n' +
              '5. 消防安全培训服务<br>\n' +
              '我们向用户单位提供专业的消防安全培训服务。培训范围涵盖火灾案例分析、消防安全常识、企业消防安全隐患排查、火灾隐患处理、消防器材使用以及火灾逃生、自救方法与技巧等内容。<br>\n' +
              '<br>\n' +
              '6. 消防维保服务<br>\n' +
              '6.1. 消防设施故障排查及处理服务<br>\n' +
              '我们向用户单位提供消防设施设备故障排查服务，解决企业因无消防专业人员管理产生消防设施故障。<br>\n' +
              '<br>\n' +
              '6.2. 人工巡检服务<br>\n' +
              '为解决企业无消防专业人员，我们向企业提供人工巡检服务，针对企业用火、用气、用电、消防重点部位、消防设施等进行人工巡检。保障企业消防安全隐患早发现，早处理，让火灾遏止在萌芽期。<br>\n' +
              '<br>\n' +
              '7. 关于公共消防安全智慧管理大数据云平台<br>\n' +
              '公共消防安全智慧管理大数据云平台以部消防救援局《关于全面推进“智慧消防”建设的指导意见》、《消防信息化“十三五”总体规划》为指引，综合运用物联网、云计算、大数据、移动互联网等新兴信息技术实现现代化、科技化、智慧化的城市消防安全管理。<br>\n' +
              '<br>\n' +
              '公共消防安全智慧管理大数据云平台立足社会消防问题导向、需求导向、目标导向，将城市消防监督管理和应急灭火救援涉及的各类要素深度融合起来，构建深度感知的消防基础环境，实现实时、动态、互动、融合的消防信息采集、传递和处理，能全面促进与提高社会单位及相关机构消防监督与管理水平，增强灭火救援的指挥、调度、决策和处置能力，全面实现火灾防控“自动化”、执法工作“规范化”、灭火救援指挥“智能化”、队伍管理“精细化”，实现“传统消防”向“现代消防”的转变。\n' +
              '\t</div>\n' +
              '</div>       \t\t\t\t\t\t</div>'},
          {ids:47,name:'移动办公APP',comp:'',issy:'',isxq:'',describe:'PC端应用在Android、ios移动设备上进行操作、显示。实现业务流转审批、业务消息推送、常用功能操作、重要数据查询等功能, 进行语音识别和控制。'},
          {ids:44,name:'5G+工业互联网应用',comp:'',logos:require('../../assets/img/yingyong/44-1.jpg'),img:require('../../assets/img/yingyong/44.jpg'),issy:'',isxq:true,describe:'发挥5G网络的上行大带宽及低时延的技术特性，结合工业互联网在人工智能、信息全集成方面的优势，在京博石化的智能立体仓库实现了关键应用，可实现塑料和橡胶产品从入库、出库、盘库以及移库的无人化管理，实现标准化自动立体存取管理',introduce:'充分发挥5G网络的上行大带宽及低时延的技术特性，结合工业互联网在人工智能、信息全集成方面的优势，在京博石化的智能立体仓库实现了关键应用，可实现塑料和橡胶产品从入库、出库、盘库以及移库的无人化管理，实现标准化自动立体存取管理，可大大减少储运费用、减轻运输人员劳动强度、降低搬运人员风险、提高仓库空间利用率。'},
        ]
      },
      {id:7,name:'质量管理',typeimg:require('../../assets/img/xzz-zlgl.jpg'),
        datas:[
          {ids:58,name:'HGCYBER MES 制造执行系统',comp:'',logos:require('../../assets/img/yingyong/58-1.jpg'),issy:'',isxq:true,describe:'平台包含工厂建模、计划排程、生产管理、设备管理、质量管理、物料管理、报表管理及系统集成等功能模块，支持多工厂部署，广泛应用于汽车及零部件、电子、装备制造及新能源（新材料）等行业',introduce: '<div class="content">\n' +
              '       \t\t\t\t\t\t<div class="detail-description-mod-content" style="color:#6F7479;font-family:-apple-system, &quot;font-size:14px;background-color:#FFFFFF;">\n' +
              '\t<div class="content-title" id="brightSpotTitle" style="font-size:16px;color:#252B3A;">\n' +
              '\t\t商品亮点\n' +
              '\t</div>\n' +
              '\t<ul class="brightSpot por-list por-list-circle" style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t<li id="brightSpot0" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t1、实时动态配置，统一、灵活的配置项管理机制；\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot1" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t2、多数据库、分布式事务支撑，高可靠性；\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot2" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t3、一键式开发环境支撑，智能简易的开发环境，充分支持定制开发；\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot3" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t4、集团化部署，集中和分布式两种部署方式，支持多租户，支持多工厂模式；\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot4" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t5、全面支持云部署、公有云、私有云；\n' +
              '\t\t</li>\n' +
              '\t</ul>\n' +
              '</div>\n' +
              '<div class="detail-description-mod-content" style="color:#6F7479;font-family:-apple-system, &quot;font-size:14px;background-color:#FFFFFF;">\n' +
              '\t<div id="detail-description-desc-title" class="content-title" style="font-size:16px;color:#252B3A;">\n' +
              '\t\t商品说明\n' +
              '\t</div>\n' +
              '\t<table class="versionTable" style="margin:12px 0px 17px;">\n' +
              '\t\t<tbody>\n' +
              '\t\t\t<tr>\n' +
              '\t\t\t\t<td id="product-description-0">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">版本:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">V2.0</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t\t<td id="product-description-1">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">交付方式:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">License</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t</tr>\n' +
              '\t\t\t<tr>\n' +
              '\t\t\t\t<td id="product-description-2">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">适用于:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">Windows/Linux/Android/iOS</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t\t<td id="product-description-3">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">上架日期:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">2020-07-27</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t</tr>\n' +
              '\t\t\t<tr>\n' +
              '\t\t\t\t<td id="product-description-4">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">交付SLA:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">180 自然日</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t\t<td id="product-description-5">\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t</tr>\n' +
              '\t\t</tbody>\n' +
              '\t</table>\n' +
              '\t<div id="detail-description-desc" class="detail-description-desc" style="color:#666A75;">\n' +
              '\t\t版本：V2.0<br>\n' +
              '适用于: Windows/Linux/Android/iOS<br>\n' +
              '交付方式：License<br>\n' +
              '上架日期：<br>\n' +
              '功能模块：<br>\n' +
              '1. 生产管控颗粒度提升<br>\n' +
              'MES系统将承接上层ERP系统的计划，将承接的计划工单展开成工作，下发到车间，车间生产线将工作分派到各个班组，工人进入系统后，看到当天的计划，工位计划的开、完工时间，加强对工人工作安排。<br>\n' +
              '2. 车间设备管理能力提升<br>\n' +
              '通过对车间生产线加工设备、工装、量具等设备的信息采集，保养检定计划的管理，以及对设备异常信息纪录及提醒。相关设备管理人员可查询相关设备、工具、量具的历史信息，基于历史数据对其可用性及利用率进行分析，提升设备管理能力。<br>\n' +
              '3. 生产过程透明能力提升<br>\n' +
              '通过MES系统的实施，有望实现实时监控车间生产情况，实现追溯过去某段时间的工作状态，使生产管理人员对生产线生产信息一目了然，同时能够及时将管控指令下发车间，第一时间获取执行状态，从而提高生产过程透明能力。<br>\n' +
              '4. 生产过程信息化能力提升<br>\n' +
              'MES系统结合PLM、ERP等信息化工具提升数字化车间无纸化能力。当MES系统与PLM、ERP等系统进行有机结合时，把工厂车间生产过程中所有与生产相关的信息和过程集成起来统一管理，为工程技术人员提供一个协同工作的环境，实现作业指导/操作说明的维护和无纸化浏览，将生产数据文档电子化管理，从而提升生产过程信息化能力。<br>\n' +
              '5. 产品质量管控能力提升<br>\n' +
              'MES系统对过程进行质量管理和控制，减少操作人员的漏步或跳步，严格遵照作业指导书进行操作。通过MES与测试设备的集成采集到的质量数据，为工程技术人员提供了准确的统计分析基础，以及通过MES对生产异常和质量问题的系统化过程管理，使产品质量控制能力持续提升。\n' +
              '\t</div>\n' +
              '</div>       \t\t\t\t\t\t</div>'},
          {ids:59,name:'西格数据数字化工厂系统软件',comp:'',logos:require('../../assets/img/yingyong/59-1.jpg'),issy:'',isxq:true,describe:'西格数据云MES方案，提供数据采集、生产管理、人员绩效、质量管理、安灯管理、看板管理等一站式功能应用，助力中小企业快速步入数字化、降本增效。',introduce: '<div class="content">\n' +
              '       \t\t\t\t\t\t<div class="detail-description-mod-content" style="color:#6F7479;font-family:-apple-system, &quot;font-size:14px;background-color:#FFFFFF;">\n' +
              '\t<div class="content-title" id="brightSpotTitle" style="font-size:16px;color:#252B3A;">\n' +
              '\t\t商品亮点\n' +
              '\t</div>\n' +
              '\t<ul class="brightSpot por-list por-list-circle" style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t<li id="brightSpot0" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t部署周期快则15分钟/台\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot1" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t满足各部门管理功能需求\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot2" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t操作简洁，工人端易推行\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot3" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t超低投资，当天见效\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot4" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t高性价比，多平台管理 （看板、网页、线边、手机app）\n' +
              '\t\t</li>\n' +
              '\t</ul>\n' +
              '</div>\n' +
              '<div class="detail-description-mod-content" style="color:#6F7479;font-family:-apple-system, &quot;font-size:14px;background-color:#FFFFFF;">\n' +
              '\t<div id="detail-description-desc-title" class="content-title" style="font-size:16px;color:#252B3A;">\n' +
              '\t\t商品说明\n' +
              '\t</div>\n' +
              '\t<table class="versionTable" style="margin:12px 0px 17px;">\n' +
              '\t\t<tbody>\n' +
              '\t\t\t<tr>\n' +
              '\t\t\t\t<td id="product-description-0">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">版本:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">V1.0</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t\t<td id="product-description-1">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">交付方式:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">SaaS</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t</tr>\n' +
              '\t\t\t<tr>\n' +
              '\t\t\t\t<td id="product-description-2">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">适用于:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">Windows/Linux/Android/iOS</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t\t<td id="product-description-3">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">上架日期:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">2020-10-20</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t</tr>\n' +
              '\t\t</tbody>\n' +
              '\t</table>\n' +
              '\t<div id="detail-description-desc" class="detail-description-desc" style="color:#666A75;">\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t西格数据数字化工厂系统软件-机加工SaaS版MES\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t【现产品开放免费试用，请直接拨打电话/或发送邮件联系申请试用，直接界面购买试用品无效】\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\tSIGER MDC（Machine Data Collecting) ，机联网系统基于组态软件和B/S架构开发，能够快速部署在客户服务器端，部署时间短，成本低，支持FANUC oi系列/30i/31i/32i等、SIEMENS、华中数控、新代、三菱M60/M70/M80等、兄弟、马扎克（MAZAK）、阿奇 夏米尔、OSP、罗德斯、牧野、海德汉、哈斯等95%以上的主流CNC控制系统；同时，SIGER MDA 也能够支持主流PLC控制器通讯和数据采集，如宇部、布勒、东芝等。<br>\n' +
              '数据采集特点：<br>\n' +
              '1.广泛适应性、方式灵活、部署迅速成本低<br>\n' +
              '2.极速报表分析、可关联数据库、可与ERP/MES对接<br>\n' +
              '3.数据采集效率提高99%<br>\n' +
              '4.系统部署效率提高95%\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t&nbsp;\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t云MES应用功能：\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t【线边端应用】\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t1.签到签出：员工上工扫码签到，下班签出，自动统计工时和考勤。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t2.生产执行（派工报工）：工人扫描工序派工单二维码获取生产任务，点击进行加工执行；生产结束后在界面直接点击报工； 系统自动采集机床加工数量； 点击报工确认即可完成报工。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t3.程序调用：直接在界面点击程序调用，自动显示与该工单产品关联的程序信息，一键调用。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t4.查看图纸：直接在界面点击工艺图纸，自动显示与该工单产品关联的工艺图纸，一键调用。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t5.质量检验：直接在终端输入检验结果。 支持首件检、巡检、完工检等。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t6.异常呼叫（安灯管理）：直接在界面点击异常呼叫，选择异常类型进行触发上报 。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t7.个人绩效：直接在界面点击个人绩效进行查看 。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t&nbsp;\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t【企业各部门管理者应用】\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t生产管理/设备状态监控：<br>\n' +
              '通过数据自动采集，实现对机加工车间生产进度、设备状态等进行管理；包括：<br>\n' +
              '1.设备状态/参数监控，防止人为修改参数带来工件异常；<br>\n' +
              '2.设备切片分析，横向、纵向对比不同设备、加工不同工件、不同时段的状态及对应的原因分析；<br>\n' +
              '3.设备报警数据管理，进行报警一览和报警数据分析，提升报警响应效率；<br>\n' +
              '4.对生产效率及时间稼动分析等。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\tDNC程序管理：Distributed Numeric Control 分布式数控，主要用于 CNC 的加工程序的集中管理、传输；<br>\n' +
              '西格数据DNC程序管理，解决了以往传输程序点对点、CF卡插拔式的低效率传输方式，将程序集中统一管理，支持：<br>\n' +
              '1.程序创建：在线编辑及版本管理；<br>\n' +
              '2.程序审核：审核控制及权限配置、权限管理；<br>\n' +
              '3.程序库管理：集中管理程序，在线程序对比，异常提醒；<br>\n' +
              '4.程序调用：远程下发，扫码工单调用程序，快速、防错；<br>\n' +
              '5.NC设备程序运行：程序实时监控保障程序安全、防篡改，程序的删除。<br>\n' +
              '通过程序管理，程序管理和传输效率提升95%，实时下发，实时在线管理程序。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t人员绩效：实现标准工时维护、报工记录审核、人员工时结算、绩效分析等功能，办公室网页端实时查看、自动生成报表，省去人工统计时间及滞后性问题。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t安灯管理：车间异常状态一览，实时掌握车间异常状况、及时应对解决；配置异常类型，设置推送流程，提升异常响应效率；自动汇总异常记录、做异常分析，降低异常响应时间。\n' +
              '\t\t</p>\n' +
              '<br>\n' +
              '\t\t<p style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t\t<br>\n' +
              '大屏看板：<br>\n' +
              '设备状态看板；<br>\n' +
              '生产管理看板；<br>\n' +
              '参观展示看板；<br>\n' +
              '满足不同场景不同管理人员的数据及管理需求。<br>\n' +
              '<br>\n' +
              '生产管理APP端/远程监控<br>\n' +
              '无论何时何地，通过手机移动端，随时掌握生产车间实时状态，移动化、便捷化。\n' +
              '\t\t</p>\n' +
              '\t</div>\n' +
              '</div>       \t\t\t\t\t\t</div>'},
          {ids:60,name:'OrBit-MES华磊迅拓企业制造执行系统',comp:'',logos:require('../../assets/img/yingyong/60-1.jpg'),issy:'',isxq:true,describe:'OrBit-MES系统提供制造数据管理、计划排产管理、生产调度管理、质量管理、设备管理、工具工装管理、项目看板管理、生产过程控制等管理模块，为企业打造一个全面的制造协同管理平台。',introduce: '<div class="content">\n' +
              '       \t\t\t\t\t\t<div class="detail-description-mod-content" style="color:#6F7479;font-family:-apple-system, &quot;font-size:14px;background-color:#FFFFFF;">\n' +
              '\t<div class="content-title" id="brightSpotTitle" style="font-size:16px;color:#252B3A;">\n' +
              '\t\t商品亮点\n' +
              '\t</div>\n' +
              '\t<ul class="brightSpot por-list por-list-circle" style="color:inherit;font-size:inherit;font-weight:inherit;">\n' +
              '\t\t<li id="brightSpot0" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t平台化——基于自主研发的OrBit-X企业基础应用平台上，支持其他信息化系统集成，有效做到数据共享，统一管理；\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot1" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t开源性——华磊迅拓OrBit-MES系统业务层代码开源，支持企业的二次开发，完全赋能企业，支撑企业的未来发展需求；\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot2" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t安全性——OrBit-MES系统建立了完善的安全检测与监控机制，安全级别达到了电商级安全标准；\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot3" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t可视化HTML5界面——OrBit-MES系统引入HTML5技术，通过调用HMTL5提供的绘图API，用计算机图形学和图形处理技术将数据转换成图形或者图像显示出来\n' +
              '\t\t</li>\n' +
              '\t\t<li id="brightSpot4" style="color:#666A75;font-weight:inherit;text-align:left;">\n' +
              '\t\t\t云端虚拟化部署——OrBit-MES系统支持云平台虚拟化部署，可以方便地部署在公有云平台上，利用云端储存和大数据分析，用户只需要接入标准的互联网访问云MES系统即可。\n' +
              '\t\t</li>\n' +
              '\t</ul>\n' +
              '</div>\n' +
              '<div class="detail-description-mod-content" style="color:#6F7479;font-family:-apple-system, &quot;font-size:14px;background-color:#FFFFFF;">\n' +
              '\t<div id="detail-description-desc-title" class="content-title" style="font-size:16px;color:#252B3A;">\n' +
              '\t\t商品说明\n' +
              '\t</div>\n' +
              '\t<table class="versionTable" style="margin:12px 0px 17px;">\n' +
              '\t\t<tbody>\n' +
              '\t\t\t<tr>\n' +
              '\t\t\t\t<td id="product-description-0">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">版本:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">V13.0</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t\t<td id="product-description-1">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">交付方式:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">License</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t</tr>\n' +
              '\t\t\t<tr>\n' +
              '\t\t\t\t<td id="product-description-2">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">适用于:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">Windows</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t\t<td id="product-description-3">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">上架日期:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">2020-04-03</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t</tr>\n' +
              '\t\t\t<tr>\n' +
              '\t\t\t\t<td id="product-description-4">\n' +
              '\t\t\t\t\t<span class="version" style="font-size:14px;color:#252B3A;line-height:18px;">交付SLA:&nbsp;</span><span class="version-value" style="font-size:14px;color:#252B3A;line-height:18px;">100 自然日</span>\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t\t<td id="product-description-5">\n' +
              '\t\t\t\t</td>\n' +
              '\t\t\t</tr>\n' +
              '\t\t</tbody>\n' +
              '\t</table>\n' +
              '\t<div id="detail-description-desc" class="detail-description-desc" style="color:#666A75;">\n' +
              '\t\t规格产品区别：<br>\n' +
              '产品购买包括2方面：平台基础费+客户端用户个数费用（按单个客户端用户数量计）。<br>\n' +
              '用户个数取决于客户工厂和生产工艺流程需要，自主选择需要授权开放多少个客户端用户数，另外收费。平台基础费为基本和固定费用。后期，客户使用平台后若需要增购客户端用户数, 我司也支持单独加购客户端用户数的新增购买服务。产品规格如下：<br>\n' +
              '产品1：华磊迅拓OrBit-MES系统平台<br>\n' +
              '产品2：华磊迅拓OrBit-MES系统客户端（1个用户）（按需购买客户端用户个数）<br>\n' +
              '<br>\n' +
              'OrBit-MES系统即制造执行系统，是深圳市华磊迅拓科技有限公司自主研发，构建于中国自有知识产权的基础业务平台之上，符合MESA/ISA-S95标准，基于批次过程控制，以及企业建模技术，是企业内部物流、生产体系、品质部门的保障系统，为企业实现JIT拉动模式、Lean精益生产、6 Sigma-TQM全面质量管理、为企业迈进 “工业4.0/中国制造2025” 打下坚实的基础。<br>\n' +
              '&emsp;&emsp;为帮助制造业应对日益复杂业务环境，在严酷的竞争环境中立于不败之地，OrBit-MES制造执行系统提供了令人瞩目的特性：高度灵活的可配置性、基于SOA架构的技术平台、能适用于JIT/精益生产、支持个性化且快速变化生产模式，它涵盖了物流及制造环节，为企业提供了完整的数据链创建以及分析套件，帮助企业通过信息的实时反馈实现对品质的预防性控制，企业在部署OrBit-MES后将变得更为透明且易于管理，能显著降低成本提升竞争力。<br>\n' +
              '&emsp;&emsp;得益于SOA架构的OrBit-X基础业务平台，OrBit-MES提供了自演化能力的建模特性，采用螺旋式渐进的敏捷实施方法论，主动匹配并优化客户的业务过程，能显著降低系统部署风险，有效提升企业执行力，助其实现核心价值，并快速取得成功。<br>\n' +
              'OrBit-MES系统技术特性<br>\n' +
              '技术架构与业务架构分离<br>\n' +
              '多工厂分布式部署<br>\n' +
              '基于浏览器-插件技术<br>\n' +
              '基于元对象-MES事务对象配置及OrBit-Script脚本驱动技术<br>\n' +
              '基于SOA架构的WCF通讯技术<br>\n' +
              '提供业务流程建模方法论与工具<br>\n' +
              '基于事件驱动的可视化工作流技术<br>\n' +
              '提供一维二维条码设计器<br>\n' +
              '支持RFID、触摸屏、机器视觉系统采集<br>\n' +
              '支持SCADA、OPC/PLC、SECS/GEM<br>\n' +
              '提供简繁英日韩法德等语言界面<br>\n' +
              '支持SQL Server 2008 / 2012 /2014<br>\n' +
              'C#VB.NETWPF 二次开发API源码<br>\n' +
              '支持WinCE / Windows Mobile / Android 移动应用<br>\n' +
              '符合MESA技术白皮书以及ISA-SP95标准\n' +
              '\t</div>\n' +
              '</div>       \t\t\t\t\t\t</div>'},
          {ids:45,name:'综合报表APP',comp:'',issy:'',isxq:'',describe:'supOS内置报表工具，以系统集成的数据为基础，根据各专业的要求开发专业管理报表及公司综合管理类报表。系统报表格式、内容、运算逻辑等由客户自定义，报表工具满足复杂格式、复杂运算逻辑的中式报表的建设需求。'},
          {ids:46,name:'综合展示APP',comp:'',issy:'',isxq:'',describe:'智能工厂相关子系统的集成与参观展示的需求，系统应制作大屏幕展示界面。大屏展示界面要求参观展示区、生产经营管理区、操作功能区功能划分明晰，内容丰富，界面友好，自动适应大屏宽高比及分辨率'},
        ]
      },
      {id:8,name:'操作优化',typeimg:require('../../assets/img/xzz-czyh.jpg'),
        datas:[
          {ids:8,name:'生产调度优化APP',comp:'',logos:require('../../assets/img/yingyong/8-1.jpg'),img:require('../../assets/img/yingyong/8.jpg'),issy:'',isxq:true,describe:'生产调度优化按照工艺数字化研发的研究成果，进行管控装置加工量和产量、装置工艺指标、物料采样指标、罐区库存等信息，对全厂物料平衡、工艺稳定、质量合格、装置运行、工艺指标、产品质量等数据的有效整合，实现重要工艺指标的实时预警与优化，保障新产品按照质量指标平稳生产。',introduce:'全厂生产长稳运行是企业运营的核心目标之一，工艺数字化研发是生产工艺优化、试验分析、新产品评估，以及试产、合成工艺调整等环节的全面管理，生产调度优化按照工艺数字化研发的研究成果，进行管控装置加工量和产量、装置工艺指标、物料采样指标、罐区库存等信息，对全厂物料平衡、工艺稳定、质量合格、装置运行、工艺指标、产品质量等数据的有效整合，实现重要工艺指标的实时预警与优化，保障新产品按照质量指标平稳生产。<br>\n' +
              '利用supOS工业操作系统提供的组态式、可视化技术，完成面向装置生产过程的工艺流程图发布，集成装置加工数据、罐区库存数据、物料数据、质量指标数据等，实现工艺指标的预警、工况的卡边操作、生产计划的调度优化。<br>\n'},
          {ids:17,name:'燃料气与氢气管网优化操作APP',issy:'',isxq:true,comp:'',logos:require('../../assets/img/yingyong/17-1.jpg'),img:require('../../assets/img/yingyong/17.jpg'),describe:'基于supOS工业操作系统，以氢气、燃料气的产耗实时数据、化验分析数据、管网结构参数为基础，构建基于物性计算、流动、传热耦合的在线机理模型，实现氢气管网的管段流量、流速、氢纯度、杂质含量的软测量；实现燃料气管网关键组分含量、热值、烃类液化状态等软测量，实时跟踪管网运行状态，实现管网异常问题与瓶颈管段的自动报警与定位功能',introduce:'基于supOS工业操作系统，以氢气、燃料气的产耗实时数据、化验分析数据、管网结构参数为基础，构建基于物性计算、流动、传热耦合的在线机理模型，实现氢气管网的管段流量、流速、氢纯度、杂质含量的软测量；实现燃料气管网关键组分含量、热值、烃类液化状态等软测量，实时跟踪管网运行状态，实现管网异常问题与瓶颈管段的自动报警与定位功能，实现管网结构参数的便捷查询、维护等功能。建立氢气系统的调度优化模型，在线给出氢气产耗装置异常、产耗不平衡工况下，氢气系统优化的调度方案；构建基于热值平衡的燃料气系统调度优化模型，在线给出燃料的优化分配方案及液态烃、天然气最佳补充方案，提升调度人员对燃料气管网运行状态的预判能力；通过优化调度产耗失衡带来的氢气浪费、燃料增补量，提升系统运行平稳性，为评估诊断、优化操作、降低公用工程系统波动提供决策依据。'},
        ]
      },
    ]
    }
  },
  mounted () {
    let ids=this.$route.query.id||''
    if(ids){
      const datal=localStorage.getItem('smartdata')
      if(datal){
        this.smartdata=JSON.parse(datal)
      }else {
        const datas=this.data_cont
        for(var i=0;i<datas.length;i++){
          const item=datas[i].datas
          const tt=item[item.findIndex((items) => items.ids*1 === ids*1)]||''
          if(tt){
            this.smartdata=tt
            return
          }
        }
      }
      localStorage.setItem('smartdata','')
    }
  },
  methods:{
    gotourl(url){
      if(url){
        let info=myStorage.getItem('localStorage','userinfo')
        if(info){
          // const infoname=info.zhnc
          // if((process.env.ACCESSP).indexOf(infoname)>=0){
            if(url.indexOf('http')<0){
              let routeData = this.$router.resolve({path: url})
              window.open(routeData.location.hash, "_blank")
            }else {
              window.open(url, "_blank")
            }
          // }else {
          //   this.$message({
          //     type: 'warning',
          //     duration:5000,
          //     message: '该功能需要访问权限才能进入，请联系管理员！'
          //   })
          // }

        }else {
          let $this=this
          this.$alert('您还未登录或登录已失效，不可以访问其他功能！', '系统提示', {
            confirmButtonText: '去登录',
            type: 'warning',
            center: true,
            callback: action => {
              localStorage.setItem('gotourl',url)
              $this.$router.push('/login')
            }
          })
        }
      }else {
        //还没有对接没有跳转路径
      }
    }
  }
}
</script>

<style scoped>
.layout-box {
  position: relative;
  width: 100%;
  height: calc(100% - 170px);
  padding-top: 170px;
  background: url("../../assets/erj_bj.fw.png");
  -moz-user-select:none; /* Firefox私有属性 */
  -webkit-user-select:none; /* WebKit内核私有属性 */
  -ms-user-select:none; /* IE私有属性(IE10及以后) */
  -khtml-user-select:none; /* KHTML内核私有属性 */
  -o-user-select:none; /* Opera私有属性 */
  user-select:none; /* CSS3属性 */
}

.secondary-content{
  width: 1100px;
  height: 100%;
  margin: 0 auto;
  position: relative;
  background: #fff;
}

.experts-title{
  width:100%;
  height: 59px;
  background-image: linear-gradient(rgba(239,243,254,.2),rgba(197,210,250,.48));
}

.experts-title h4{
  color: #fff;
  line-height: 59px;
  text-align: center;
  font-size: 21px;
  letter-spacing: 5px;
  text-shadow:0 4px 5px rgba(0, 0, 0, 0.3);
}

.bread-crumb-nav{
  font-size: 16px;
  font-family: 微软雅黑;
  line-height: 59px;
  padding-left: 20px;
}

.bread-crumb-nav a{
  cursor: pointer;
  text-decoration: none;
}
.bread-crumb-nav a:hover{
  text-decoration: underline;
  font-weight: bold;
}

.experts-detail{
  width: 100%;
  font-size: 16px;
  line-height: 217%;
  overflow: auto;
  height: calc(100% - 60px);
  position: relative;
}

.experts-detail::-webkit-scrollbar{
  display: none;
}

.character-profile{
  width: 100%;
  padding: 40px 40px 90px;
  position: relative;
  box-sizing: border-box;
  box-shadow:0 4px 8px 0 rgba(100, 100, 100, 0.1), 0 6px 20px 0 rgba(100, 100, 100, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.character-profile-div{
  margin-left: 20px;
  flex: 1;
}

.character-profile h3{
  font-size: 26px;
  margin-bottom: 10px;
}

.character-profile p{
  line-height: 160%;
  width: 100%;
  margin: 3px 0;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.character-profile p.research{
  white-space:normal;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  word-break: break-all;
  color: #666;
}

.pingjia{
  background: #F4F5F7;
  padding: 10px 15px;
  margin-top: 12px;
}

.pingjia p{
  line-height: 210%;
  color: #333;
}

.pingjia i{
  margin-right: 4px;
  color: #C6D1DE;
}

.character-profile img{
  width: 300px;
  max-height: 450px;
  overflow: hidden;
  flex-shrink:0
}

.main-works{
  padding: 0 10px 15px 10px;
  margin: 0 40px;
  border-bottom: 1px solid #E3E9F6;
  position: relative;
}

.main-works p{
  margin-top: 15px;
}

.details-introduction{
  padding: 20px;
  margin: 0 40px 40px;
  background: #F6F6F6;
}

.details-introduction img {
  max-width: 100%;
  display: block;
  margin: 10px auto;
}

.details-introduction p {
  text-align: left;
  font-size: 18px;
  line-height: 200%;
}

.purchase-intention{
  position: absolute;
  z-index: 5;
  bottom:20px;
  right: 40px;
}

.purchase-intention a{
  background: #9FA5B4;
  border: 1px solid #9FA5B4;
  font-size: 18px;
  display: inline-block;
  color: #fff;
  padding: 8px 50px;
  margin-left: 8px;
}

a.btn-xq{
  cursor: pointer;
  background: #FFA21A;
  border-color: #FFA21A;
}

a.btn-xq:hover{
  background: #F79400;
}

a.btn-sy{
  cursor: pointer;
  background: #fff;
  color: #FFA21A;
  border-color: #FFA21A;
}

a.btn-sy:hover{
  background: #F79400;
  color: #fff;
}

</style>

<style>
.details-introduction .content-title{
  font-weight: bold;
  line-height: 36px;
}

.details-introduction .content img{
  max-width: 100%;
  display: block;
  margin: 10px auto;
}

.details-introduction table{width:100%;margin-bottom:10px;}
.details-introduction table td{border:solid 1px #dfe1e6;font-weight:bold;padding:10px;}
.details-introduction table tr:nth-child(1){background:#eaecf0;}
</style>



// WEBPACK FOOTER //
// src/views/secondary/new-smart-detail.vue